/* eslint import/prefer-default-export: 0 */
export const legal = {
  pvq: {
    intro: {
      title: 'Investigative and criminal history',
      body:
        'You will be asked questions about your investigative and criminal background and be asked to provide details if necessary.',
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      para: 'View all the sections associated with investigative & criminal history at once',
    },
    section: {
      name: 'Investigative and criminal history',
    },
    subsection: {
      intro: 'Introduction',
      criminalconvictions: 'Criminal Convictions Resulting in Sentences Over One Year',
      investigations: {
        label: 'Investigations and clearance record',
        intro: 'Introduction',
        history: 'Investigation history',
        clearanceissues: 'Security clearance issues',
        pivissues: 'Personal Identity Verification issues',
        foreign: 'Foreign investigation',
        debarred: 'Debarment',
      },
      police: {
        label: 'Police record',
        intro: 'Introduction',
        offenses: 'Offenses',
        additionalOffenses: 'Additional offenses',
        domesticViolence: 'Domestic violence',
        policeRecord: 'Police Record'
      },
      associations: {
        terroristOrganizationMembership: 'Terrorist Organization Membership',
        terrorismEngagement: 'Terrorism Engagement',
        terrorismAdvocacy: 'Terrorism Advocacy',
        rightsSuppressionGroup: 'Rights Suppression Group',
        violentRightsSuppressionGroup: 'Violent Rights Suppression Group',
        violentOrganization: 'Violent Organization',
        violentActs: 'Violent Acts',
        hateCrimeAdvocacy: 'Hate Crime Advocacy',
        internationalAndDomesticTerrorism: 'International And Domestic Terrorism',
        internationalAndDomesticTerrorismEngagement: 'International And Domestic Terrorism Engagement',
        internationalAndDomesticTerrorismAssociation: 'International And Domestic Terrorism Association',
        internationalAndDomesticTerrorismAdvocacy: 'International And Domestic Terrorism Advocacy',
      },
      technology: {
        label: 'Use of information technology systems',
        intro: 'Introduction',
        unauthorized: 'Unauthorized access',
        manipulating: 'Manipulating access',
        denied: 'Denied use',
        unlawful: 'Unlawful use',
      },
      review: 'Review',
    },
    destination: {
      intro: 'Investigative and criminal history intro',
      'police/intro': 'Police record',
      'police/offenses': 'Offenses',
      'police/policerecord': 'Police Record',
      'police/additionaloffenses': 'Additional offenses',
      'police/domesticviolence': 'Domestic violence',
      court: 'Non-criminal court actions',
      criminalconvictions: 'Criminal Convictions Resulting in Sentences Over One Year',
      'investigations/intro': 'U.S. personnel vetting investigations, security clearances, and federal debarments',
      'investigations/history': 'Ever been investigated',
      'investigations/clearanceissues': 'Clearance issues',
      'investigations/revoked': 'Denied',
      'investigations/pivissues': 'Personal identity verification issues',
      'investigations/debarred': 'Debarment',
      'investigations/foreign': 'Foreign investigations',
      'technology/unauthorized': 'Unauthorized access',
      'technology/manipulating': 'Manipulating access',
      'technology/unlawful': 'Unlawful use',
      'technology/denied': 'Denied use',
      'technology/intro': 'Intro',
      'technologyprotected/intro': 'Introduction',
      'technologyprotected/protectedunauthorized': 'Handling Protected Information',
      'technologyprotected/noncompliance': 'Deliberate Non-Compliance',
      'technology/protected': 'Handling Protected Information',
      'associations/terrorist-organization': 'Terrorist organization',
      'associations/engaged-in-terrorism': 'Engaged in terrorism',
      'associations/advocating': 'Advocating',
      'associations/membership-overthrow': 'Membership - overthrow',
      'associations/membership-violence-or-force': 'Membership - violence or force',
      'associations/activities-to-overthrow': 'Activities to overthrow',
      'associations/terrorism-association': 'Terrorism association',
      review: 'Review investigative & criminal history',
      'associations/terrorist-organization-membership': 'Terrorist organization membership',
    },

    protectedInformation: {
      heading: {
        title: 'Section 17: Handling Protected Information',
        body:
          'You will be asked questions about your handling of protected information and be asked to provide details if necessary.',
      },
      para: {
        intro0: 'This section asks for information regarding your handling of protected information, as applicable. ',
        intro1:
          '- Protected information includes information protected by the Privacy Act, personally identifiable information, proprietary information, classified information, and other sensitive or protected information.',
        intro2:
          '- The term "illegal" applies whether or not you were arrested, charged, or convicted of a crime.',
        intro3:
          '- Your truthful responses and any information derived from your responses will not be used as evidence against you in a subsequent criminal proceeding. This applies whether or not you are employed by the Federal Government.',
        intro4:
          '- Do NOT include classified information or any specifics regarding other protected information or classified IT systems in any of your responses.',
      },
      subsection: {
        intro: 'Introduction',
        protected: 'Handling Protected Information',
        label: 'Handling Protected Information',
        unauthorized: {
          title: 'Have you illegally or without proper authorization accessed or tried to access any protected information in the past five years ?',
          date: 'When did you illegally or without proper authorization access or try to access this protected information?',
          accessLocation: 'From what location did you illegally or without proper authorization access or try to access this protected information?',
          checkAll: 'Select all that apply',
          otherLocationExplanation: 'Please explain.',
          location: 'Is this location in the U.S.?',
          domesticTitle: 'What is the address?',
          foreignTitle: 'Where is this located? \nPlease provide the physical address (not mailing address).',
          streetLabel: 'Street',
          installationLabel: 'Is this a U.S. military installation or U.S. diplomatic facility?',
          accessAttemptOutcome: 'Did you succeed in accessing protected information?',
          accessedInformationExplanation: 'What did you do with this protected information?',
          accessAttemptReason: 'Why did you illegally or without proper authorization access or try to access this protected information?',
          accessAttemptDisciplinaryAction: 'Did you receive any of the following actions for accessing or trying to access this protected information?',
          disciplinaryActionOtherExplanation: 'Please explain.',
          disciplinaryActionExplanation: 'Provide details. (Include a description of the action taken against you, who took this action, when you received this action, where you received this action, and any other details.)',
          appendTitle: 'Do you have another instance in which you illegally or without proper authorization accessed or tried to access protected information?',
          appendLabel: 'Add another unauthorized access',
          summaryItem: 'Incident',
        },
        noncompliance: {
          pageTitle: 'Deliberate Non-Compliance',
          label: 'Deliberate Non-Compliance',
          title: 'Have you deliberately non-complied with rules or regulations for safeguarding protected information in the past five years?',
          date: 'When did you deliberately non-comply with rules or regulations for the safeguarding of this protected information?',
          accessLocation: 'Where did you deliberately non-comply with rules or regulations for the safeguarding of this protected information?',
          checkAll: 'Select all that apply',
          otherLocationExplanation: 'Please explain.',
          location: 'Is this location in the U.S.?',
          domesticTitle: 'What is the address',
          foreignTitle: 'Where is this location?',
          accessAttemptOutcome: 'Did you succeed in accessing protected information?',
          accessedInformationExplanation: 'What did you do with this protected information?',
          nonComplianceReason: 'Why did you deliberately non-comply with rules or regulations for safeguarding this protected information?',
          nonComplianceDisciplinaryAction: 'Did you receive any of the following actions for deliberately non-complying with rules or regulations for safeguarding this protected information?',
          disciplinaryActionOtherExplanation: 'Please explain.',
          disciplinaryActionExplanation: 'Provide details. (Include a description of the action taken against you, who took this action, when you received this action, where you received this action, and any other details.)',
          collection: {
            description: 'Summary of non-compliance incidents',
            item: 'Non-Compliance',
            unknown: 'Provide non-compliance incident details below',
            appendTitle: 'Do you have another instance in which you deliberately non-complied with rules or regulations for safeguarding protected information in the past five years?',
            appendLabel: 'Add another non-compliance incident',
          },
        },
      },
    },
    investigations: {
      heading: {
        title: 'Section 14: U.S. Personnel Vetting Investigations, Security Clearances, and Federal Debarments',
        body:
          'You will be asked questions about your investigative and criminal background and be asked to provide details if necessary.',
      },
      para: {
        intro1:
          'This section asks for information regarding any personnel vetting investigations the U.S. Government has conducted on you as part of the personnel vetting process. All individuals who work for or on behalf of the U.S. federal government are investigated at least once. After the initial investigation, further investigations depend on many variables.',
        intro2:
          'Some investigations result in a security clearance determination or a determination of eligibility to occupy a sensitive position. This section asks questions regarding your eligibility determination or security clearance determination, if applicable. Information requested includes whether or not you were granted eligibility to occupy a sensitive position or a security clearance or have had either denied, suspended, or revoked. The U.S. federal agency that investigated you may or may not be the same U.S. federal agency that granted, denied, suspended, or revoked your security clearance.',
        intro3:
          'This section also asks for information regarding whether or not the U.S. Government has debarred you from Federal employment. If you were found unsuitable under 5 CFR 731 by the U.S. Office of Personnel Management or an agency, a period during which you were denied examination for, and appointment to, all or specific covered positions within the U.S. Government is considered a debarment period. Your debarment could be either government-wide or from a particular agency or positions within that agency.',
        intro4:
          'Investigations are also used to determine whether you are eligible for a Personal Identity Verification (PIV) credential. This credential grants you physical access to Federal space and/or logical access to federal information technology (IT) systems. This section asks questions regarding any prior credentialing decisions where you were denied a PIV or had a PIV suspended or revoked, as applicable.',
        intro5:
          'We also want to know if a foreign government has ever investigated you or granted you a security clearance. Foreign means non-U.S. -- that is, outside of the 50 U.S. states, District of Columbia, and U.S. territories.',
      },
      outcome: {
        suspended: 'Still suspended',
        revoked: 'Revoked',
        reinstated: 'Reinstated',
        other: 'Other',
        explain: 'Please explain.'
      },
      history: {
        heading: {
          title:
            'In the last five years, has the U.S. Government investigated your background as part of the personnel vetting process, such as for your suitability or fitness for employment, your eligibility for a PIV credential, or for a national security position or security clearance?',
          agency: 'Which federal agency investigated your background?',
          agencyexplanation: 'Please explain',
        },
        label: {
          idk: "I don't know",
          agency: {
            cia: 'Central Intelligence Agency (CIA)',
            afosi: 'DoD - Air Force Office of Special Investigations (AFOSI)',
            dcsa: 'DoD - Defense Counterintelligence and Security Agency (DCSA)',
            dia: 'DoD - Defense Intelligence Agency (DIA)',
            nga: 'DoD - National Geospatial-Intelligence Agency (NGA)',
            nro: 'DoD - National Reconnaissance Office (NRO)',
            nsa: 'DoD - National Security Agency (NSA)',
            cbp: 'DHS - Customs and Border Protection (CBP)',
            fema: 'DHS - Federal Emergency Management Agency (FEMA)',
            dhshq: 'DHS - Headquarters (DHS-HQ)',
            ice: 'DHS - Immigration and Customs Enforcements (ICE)',
            tsa: 'DHS - Transportation Security Agency (TSA)',
            uscg: 'DHS - U.S. Coast Guard (USCG)',
            uscis: 'DHS - U.S. Customs and Immigration Service (USCIS)',
            usss: 'DHS - U.S. Secret Service (USSS)',
            atf: 'DOJ - Bureau of Alcohol, Tobacco, Firearms and Explosives (ATF)',
            fbi: 'DOJ - Federal Bureau of Investigation (FBI)',
            dos: 'U.S. Department of State (DoS)',
            tbep: 'Treasury - Bureau of Engraving and Printing',
            tbfs: 'Treasury - Bureau of Fiscal Services',
            mcc: 'Millennium Challenge Corporation',
            opm: 'Office of Personnel Management (OPM)',
            tva: 'Tennessee Valley Authority (TVA)',
            usaid: 'U.S. Agency for International Development (USAID)',
            uspc: 'U.S. Peace Corps (USPC)',
            uspis: 'U.S. Postal Inspection Service (USPIS)',
            idk: "I don't know",
            other: 'Other'
          },
          level: {
            none: 'None',
            confidential: 'Confidential',
            secret: 'Secret',
            topsecret: 'Top Secret',
            sci: 'Sensitive Compartmented Information (SCI)',
            q: 'Q',
            l: 'L',
            foreign: 'Issued by foreign country',
            other: 'Other (provide explanation)',
          },
        },
        para: {
          or: 'or',
        },
        collection: {
          description: 'Summary of investigations',
          item: 'Investigation',
          unknown: 'Provide investigation details below',
          appendTitle: 'Do you have another investigation to report within the last five years?',
          appendLabel: 'Add another investigation',
        }
      },
      clearancehistory: {
        heading: {
          title: 'Has the U.S. Government ever granted you a security clearance?',
          agency: 'Which federal agency granted you this security clearance?',
          agencyexplanation: 'Please explain'
        },
        collection: {
          description: 'Summary of granted security clearances',
          item: 'Security Clearance',
          unknown: 'Provide security clearance details below',
          appendTitle: 'Do you have another security clearance to report?',
          appendLabel: 'Add another security clearance',
        }
      },
      clearanceissues: {
        suspended: {
          heading: {
            title:
              'Has the U.S. Government ever suspended your security clearance or your eligibility to occupy a sensitive position?',
            agency: 'What federal agency suspended your security clearance or your eligibility to occupy a sensitive position?',
            explanation:
              'Please explain',
            date: 'When did this federal agency suspend your  security clearance or your eligibility to occupy a sensitive position?',
            reason: 'Why did this federal agency suspend your security clearance or your eligibility to occupy a sensitive position?',
            outcome: 'What was the outcome of your security clearance or your eligibility to occupy a sensitive position suspension?'
          },
          label: {
            idk: "I don't know",
          },
          collection: {
            description: 'Summary of suspensions',
            item: 'Suspension',
            unknown: 'Provide suspension details below',
            appendTitle:
              'Do you have another instance of a security clearance or eligibility to occupy a sensitive position suspension to report?',
            appendLabel: 'Add another suspension',
          },
          para: {
            or: 'or',
          },
          help: {
            date: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            agency: {
              title: 'Need help with the agency authorization this termination?',
              message:
                'Provide the agency name to the best of your abilities responsible for authorizing this action.',
              note: '',
            },
            explanation: {
              title: 'Details of this action',
              message: 'Go into as much detail as necessary.',
              note: '',
            },
          },
        },
        denied: {
          heading: {
            title:
              'Has the U.S. Government ever denied you a security clearance or eligibility to occupy a sensitive position?',
            agency: 'Which federal agency denied you a security clearance or eligibility to occupy a sensitive position?',
            date:
              'When did this federal agency deny you a security clearance or eligibility to occupy a sensitive position?',
            explanation:
              'Why did this federal agency deny you a security clearance or the eligibility to occupy a sensitive position?',
          },
          label: {
            idk: "I don't know",
          },
          collection: {
            description: 'Summary of denials',
            item: 'Denial',
            unknown: 'Provide denial details below',
            appendTitle:
              'Do you have another instance of a security clearance or eligibility to occupy a sensitive position denial to report?',
            appendLabel: 'Add another denial',
          },
          para: {
            or: 'or',
          },
          help: {
            date: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            agency: {
              title: 'Need help with the agency authorization this termination?',
              message:
                'Provide the agency name to the best of your abilities responsible for authorizing this action.',
              note: '',
            },
            explanation: {
              title: 'Details of this action',
              message: 'Go into as much detail as necessary.',
              note: '',
            },
          },
        },
        revoked: {
          heading: {
            title:
              'Has the U.S. Government ever revoked your security clearance or your eligibility to occupy a sensitive position that was not previously reported on this form? (An administrative downgrade or administrative termination of a security clearance is not a revocation.)',
            date:
              'When did this federal agency revoke your security clearance or your eligibility to occupy a sensitive position?',
            agency: 'What federal agency revoked your security clearance or your eligibility to occupy a sensitive position?',
            explanation:
              'Why did this federal agency revoke your security clearance or your eligibility to occupy a sensitive position?',
          },
          para: {
            or: 'or',
            downgrade:
              'Note: An administrative downgrade or administrative termination of a security clearance is not a revocation.',
          },
          label: {
            idk: "I don't know",
          },
          collection: {
            description: 'Summary of revocations',
            item: 'Revocation',
            unknown: 'Provide revocation details below',
            appendTitle:
              'Do you have another security clearance or eligibility to occupy a sensitive position revocation to report?',
            appendLabel: 'Add another revocation',
          },
          help: {
            date: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            agency: {
              title: 'Need help with the agency authorization this termination?',
              message:
                'Provide the agency name to the best of your abilities responsible for authorizing this action.',
              note: '',
            },
            explanation: {
              title: 'Details of this revocation action',
              message: 'Go into as much detail as necessary.',
              note: '',
            },
          },
        },

      },
      pivissues: {
        suspended: {
          heading: {
            title:
              'Has the U.S. Government ever suspended your Personal Identity Verification (PIV) credential eligibility?',
            agency: 'What federal agency suspended your PIV credential eligibility?',
            explanation:
              'Please explain',
            reason: 'Why did this federal agency suspend your PIV credential eligibility?',
            outcome: 'What was the outcome of your PIV credential eligibility suspension?',
            date: 'When did this federal agency suspend your PIV credential eligibility?',
            reinstatedDate: 'When was your PIV credential eligibility reinstated?'

          },
          label: {
            idk: "I don't know",
          },
          collection: {
            description: 'Summary of suspensions',
            item: 'Suspension',
            unknown: 'Provide suspension details below',
            appendTitle:
              'Do you have another instance in which the U.S. Government suspended your PIV credential eligibility?',
            appendLabel: 'Add another suspension',
          },
          para: {
            or: 'or',
          },
          help: {
            date: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            agency: {
              title: 'Need help with the agency authorization this suspension?',
              message:
                'Provide the agency name to the best of your abilities responsible for authorizing this action.',
              note: '',
            },
            explanation: {
              title: 'Details of this action',
              message: 'Go into as much detail as necessary.',
              note: '',
            },
          },
        },
        denied: {
          heading: {
            title:
              'Has the U.S. Government ever denied your PIV credential eligibility?',
            agency: 'Which federal agency denied your PIV credential eligibility?',
            date:
              'When did this federal agency deny your PIV credential eligibility?',
            explanation:
              'Why did this federal agency deny your PIV credential eligibility?',
          },
          label: {
            idk: "I don't know",
          },
          collection: {
            description: 'Summary of denials',
            item: 'Denial',
            unknown: 'Provide denial details below',
            appendTitle:
              'Do you have another instance in which the U.S. Government denied you a PIV credential eligibility?',
            appendLabel: 'Add another denial',
          },
          para: {
            or: 'or',
          },
          help: {
            date: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            agency: {
              title: 'Need help with the agency authorization this termination?',
              message:
                'Provide the agency name to the best of your abilities responsible for authorizing this action.',
              note: '',
            },
            explanation: {
              title: 'Details of this action',
              message: 'Go into as much detail as necessary.',
              note: '',
            },
          },
        },
        revoked: {
          heading: {
            title:
                  'Has the U.S. Government ever revoked your PIV credential eligibility that was not previously reported on this form? ',
            agency: 'Which federal agency revoked your PIV credential eligibility?',
            date:
              'When did this federal agency revoked your PIV credential eligibility?',
            explanation:
              'Why did this federal agency revoked your PIV credential eligibility?',
          },
          para: {
            or: 'or',
          },
          label: {
            idk: "I don't know",
          },
          collection: {
            description: 'Summary of revocations',
            item: 'Revocation',
            unknown: 'Provide revocation details below',
            appendTitle:
              'Do you have another instance in which the U.S. Government revoked your PIV credential eligibility?',
            appendLabel: 'Add another revocation',
          },
          help: {
            date: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            agency: {
              title: 'Need help with the agency authorization this termination?',
              message:
                'Provide the agency name to the best of your abilities responsible for authorizing this action.',
              note: '',
            },
            explanation: {
              title: 'Details of this revocation action',
              message: 'Go into as much detail as necessary.',
              note: '',
            },
          },
        },

      },
      foreign: {
        heading: {
          title:
            'Has a foreign (non-U.S.) government ever investigated your background or granted you a security clearance?',
          foreignGovernment: 'Which foreign government investigated you?',
          granted: 'Did this foreign government grant you a security clearance?'
        },
        collection: {
          description: 'Summary of foreign investigations',
          item: 'Foreign Investigation',
          unknown: 'Provide investigation details below',
          appendTitle: 'Do you have another instance in which this or another foreign (non-U.S.) government investigated your background or granted you a security clearance?',
          appendLabel: 'Add another investigation',
        },
        para: {
          or: 'or',
        },
        label: {
          idk: "I don't know",
        }
      },
      debarred: {
        heading: {
          title:
            'Have you ever been debarred from federal government employment?',
          agency: 'Which federal agency debarred you from federal government employment?',
          date: 'When were you debarred from federal  government employment?',
          explanation: 'Why were you debarred from federal government employment?',
        },
        collection: {
          description: 'Summary of debarments',
          item: 'Debarment',
          unknown: 'Provide debarment details below',
          appendTitle: 'Do you have another instance in which you were debarred from federal government employment?',
          appendLabel: 'Add another debarment',
        },
        para: {
          or: 'or',
        },
        label: {
          idk: "I don't know",
        },
        help: {
          date: {
            title: 'Estimate the dates if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          agency: {
            title: 'Need help with the agency taking the debarment action?',
            message:
              'Provide the agency name to the best of your abilities responsible for this action.',
            note: '',
          },
          explanation: {
            title: 'Details of this action',
            message: 'Go into as much detail as necessary.',
            note: '',
          },
        }
      }
    },

    criminalConvictions: {
      intro: {
        title: 'Section 29 - Criminal Convictions Resulting in Sentences Over One Year',
        body: 'This section asks for information regarding any criminal convictions that resulted in a sentence of over one year imprisonment and in which you served at least one year of that sentence. This information is needed to determine whether you may be affected by the Bond Amendment, Public Law 110-181 of January 1, 2008, which establishes restrictions on eligibility for access to some types of information (also cited as 50 U.S.C. § 3343).'
      },
      para: {
        bullet1:
          '- Report information even if your record has been expunged, sealed, or otherwise stricken from the court record',
        bullet2:
          '- Report convictions even if you entered a plea of nolo contendere (no contest).',
        bullet3:
          '- Nolle Prossed – this is a Latin phrase occasionally used by the court system which means the case against you will no longer be prosecuted or was dismissed by the prosecution.',
        bullet4:
          '- Do not report convictions under the Federal Controlled Substances Act for which the court issued an expungement order under the authority of 21 U.S.C. § 844 or 18 U.S.C. § 3607.',
        bullet5:
          '- Omit any violation of law committed before your 18th birthday if finally decided in juvenile court or appealed from juvenile court to a higher court and dismissed.',
      },

      para2: {
        subtitle: 'For this section:',
        bullet1: '- Domestic violence is a crime of violence (such as battery or assault) against your child; dependent; current or former spouse; current or former partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or, someone with whom you share a child in common. This includes crimes that meet this definition even if the term “domestic violence” is not specifically used in the criminal charge or conviction',
      },
      hasCriminalConvictions: {
        collection: {
          label: 'Were you ever convicted of a crime in a U.S. court where 1) you were sentenced to over one year imprisonment and 2) you served at least one year of that sentence? (U.S. courts include Federal, state, local, tribal, or military.)',
          appendTitle: 'Do you have another instance in which you were convicted of a crime in a U.S. court where 1) you were sentenced to over one year imprisonment and 2) you served at least one year of that sentence? (U.S. courts include Federal, state, local, tribal, or military.)',
          description: 'Summary of Criminal Convictions',
          summary: 'Provide your conviction details below',
          appendLabel: 'Do you have another instance in which you were convicted of a crime in a U.S. court where 1) you were sentenced to over one year imprisonment and 2) you served at least one year of that sentence? (U.S. courts include Federal, state, local, tribal, or military.)',
          itemType: 'Criminal Conviction',
        },
        items: {
          isReportedInAnotherSec: 'Did you report this conviction in another section of this form?',
          natureOfAction: 'Describe in detail the nature of the offense. (Include what happened, where the offense occurred, who was involved, what was the motivation, and any other details.)',
          offenseDate: 'When did the offense happen?',
          violence: 'Was domestic violence involved?',
          firearms: 'Were firearms involved?',
          explosives: 'Were explosives involved?',
          drugs: 'Were drugs involved?',
          alcohol: 'Was alcohol involved?',
          charges: 'Do you have another charge for this offense to report?',
          courtCharge: 'What were you charged with? (If there is more than one charge for this offense, input one. There will be an opportunity to input multiple entries. You must include charges that were dismissed, disposed of, or nolle prossed.)',
          chargeType: 'What type of charge is this?',
          chargeTypeOtherExplanation: 'Please Explain',
          courtOutcome: 'What was the outcome of this charge?',
          courtOutcomeOtherExplanation: 'Please Explain',
          convictedDate: 'When were you convicted?',
          sentenceJudgements: 'What was your sentence? (Check all that apply.)',
          sentenceJudgementOtherExplanation: 'Please Explain',
          probationDates: 'What were the dates of your probation?',
          incarceratedDates: 'When were you imprisoned?',
          grantedParole: 'Were you granted parole or supervised release?',
          grantedParoleDates: 'What were the dates of your parole or supervised release?',
          caseClosedDate: 'What date was your case closed?',
          caseNotClosed: 'Not Closed',
          caseNotClosedExplanation: 'Please explain',
          courtName: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtAddress: 'Is this court in the US?',
          domesticTitle: 'What is the court\'s address?',
          foreignTitle: 'Where is this court located?',

        },
        offenseInvolvements: {
          violence: 'Was domestic violence involved?',
          firearms: 'Were firearms involved?',
          explosives: 'Were explosives involved?',
          drugs: 'Were drugs involved?',
          alcohol: 'Was alcohol involved',
        },

      },
    },

    civilCourtIntro: {
      title: 'Section 24: Civil Court Actions',
      info: {
        text1:
          'This section asks for information regarding any civil court actions you have been a party to in the past five years, as applicable. Information requested includes who were the parties involved, the circumstances surrounding the case, and the outcome.',

        text2:
          'For this section:',
        text3:
          '- Civil court actions are noncriminal lawsuits filed by a plaintiff against a defendant. Civil court actions may also be referred to as civil cases, civil proceedings, or civil suits. Please do not report divorce or non-criminal civil infractions (like traffic violations) under this section.',
        text4:
          '- A party means you were either a plaintiff or defendant to the lawsuit. A plaintiff is the person who is filing the lawsuit. The defendant is the person who is responding to the lawsuit. In some courts, a defendant is called a respondent',
      },

    },
    nonCriminalAction: {
      heading: {
        hasCourtActions: /* here */
          'In the past {{numberOfYearsString}}, were you a party to any civil court action? List one at a time. You will be provided the opportunity to report additional civil actions. ',
        applicantCourtPartyStatus: 'Were you the Plaintiff or the Defendant?',
        oppositionPartyName: 'What is the name of the other party in this civil court action?',
        oppositionCourtPartyStatus: 'Is this person a Plaintiff or Defendant?',
        additionalOppositions: 'Do you have another party in this civil court action to report?',

        civilActionDate: 'Provide the date of the civil action',
        courtName: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
        isCourtInUS: 'Is this court in the US?',
        domesticTitle: 'What is the court\'s address?',
        foreignTitle: 'Where is this court located?',
        natureOfAction: 'Describe in detail the nature of this civil court action. (Include what happened, where the event occurred, who was involved, what was the motivation, and any other details.)',
        isCivilCourtActionClosed: 'Is this civil action closed?',
        civilCourtActionClosedDate: 'When was this civil court action closed?',
        outcomeOfAction: 'What was the outcome of this civil court case? (Select all that apply)',
        otherCourtOutcomeExplanation: 'Please explain',
        scheduledCourtDate: 'When are you scheduled to go to court?',
        isCivilActionAPublicRecord: 'Is this civil court action a matter of public record?',
        resultsOfAction: 'Provide a description of the results of the action',
        principalPartyNames:
          'Provide the name(s) of the principal parties involved in the court action',
      },
      courtOutcomeOptions: {
        awardedDamages: 'I was awarded damages',
        awardedRestitution: 'I was awarded restituion',
        awardedOtherRemedies: 'I was awarded other remedies',
        payDamages: 'I had to pay damages',
        payRestitution: 'I had to make restitution',
        otherRemedies: 'I had to do other remedies',
        other: 'Other'
      },

      collection: {
        description: 'Summary of court actions',
        summary: 'Provide your court action details below',
        appendTitle: 'Are there any other civil court actions in the last five (5) years to report?',
        appendLabel: 'Add another court action',
        itemType: 'Court Action',
      },
      help: {
        civilActionDate: {
          title: "Can't remember the exact date?",
          message: 'Give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        courtName: {
          title: 'Need help with the court name?',
          message: 'Provide the name of the court',
          note: '',
        },
        courtAddress: {
          title: 'Try looking up the court name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        natureOfAction: {
          title: 'Need help with the nature of the action?',
          message: 'Provide the address of the court',
          note: '',
        },
        resultsOfAction: {
          title: 'Need help with the results of the action?',
          message: 'Provide a description of the results of the action',
          note: '',
        },
        principalPartyNames: {
          title: 'Need help with the principal parties involved?',
          message: 'Provide the name(s) of the principal parties involved in the court action',
          note: '',
        },
      },
    },

    police: {
      heading: {
        title: 'Police record',
        policeRecord: 'Police Record',
        policeRecordIntro: 'This question asks for information regarding offenses where you received a document listing criminal charges and were requested to appear in criminal court. These documents are typically for offenses such as misdemeanors, felonies, or their equivalents. The written documents could include citations, summonses, tickets, complaints, arrest warrants, or indictments.',
        policeRecordCharged: 'Were you charged with a felony **more than {{numberOfYearsString}}** ago?',
        policeRecordFirearms: 'Were you charged with a crime involving firearms or explosives  **more than {{numberOfYearsString}}** ago?',
        policeRecordDomesticViolence: 'Were you convicted of a crime involving domestic violence  **more than {{numberOfYearsString}}** ago?',
        offenseArrestingAgency: 'What is the name of the law enforcement agency that arrested you? (Do not use acronyms)',
        offenseArrestingAgencyAddress: 'Is this law enforcement agency in the U.S.?',
        offenseCourtStatus: 'Did you go to court or are you waiting to go to court?',
        offenseCourtFinePayment: 'Did you pay a fine?',
        offenseCourtFineAmount: 'How much was this fine?',
        offenseCourtFinePaidInFull: 'Did you pay this fine in full?',
        offenseCourtFinePaidInFullDate: 'When did you pay this fine in full?',
        offenseCourtToAppear: 'What is the name of the court you appeared in or are to appear in? (Do not use acronyms)',
        offenseCourtToAppearAddress: 'Is this court in the U.S.?',
        offenseSentencingDate: 'When is your sentencing?',
        offenseSentencingDatePassedTense: 'When was your sentencing?',
        date: 'What is the date of the offense?',
        dateOtherOffenseArrest: 'When were you arrested?',
        dateOtherOffenseOccurred: 'What is the date of the offense for which you were arrested?',
        otherOffenseLocation: 'Did this offense occur in the U.S.?',
        otherOffenseAddress: 'Where did it occur?',
        otherOffenseReasonNotCharged: 'What was the official reason you weren\'t charged?',
        description: 'Why were you charged, cited, summoned, or ticketed? (Describe the offense to include what happened, who was involved, what the motivation was, and any other details. If domestic violence, firearms, explosives, drugs, or alcohol were involved in the offense, please explain.)',
        descriptionotheroffense: 'Why were you arrested? (Describe the circumstances that led to your arrest.)',
        involvement: 'Did this offense involve any of the following?',
        address: 'Did this offense occur in the U.S.?',
        cited:
          'Were you arrested, summoned, cited, or did you receive a ticket to appear as a result of this offense by any police officer, sheriff, marshal or any other type of law enforcement official?',
        citedagency: 'What is the name of the law enforcement agency involved? (Do not use acronyms.)',
        citedby: 'Provide the name of the law enforcement agency that arrested/cited/summoned you.',
        citedbyContinuation: '',
        agencyaddress: 'Is the law enforcement agency in the U.S.?',
        charged:
          'Were you arrested for this offense?',
        otherlawenforcementagency: 'Did the same law enforcement agency you listed above arrest you?',
        courtinfo: 'Court Information',
        arrestingagency: 'What is the name of the law enforcement agency that arrested you? (Do not use acronyms.)',
        courtname: 'Provide the name of the court',
        courtaddress: 'Provide the location of the court',
        chargeDetails:
          'Provide all the charges brought against you for this offense, and the outcome of each charged offense',
        chargeDetailsContinuation: '',
        chargeType: 'Type of charge',
        courtdate: 'When is your court date?',
        sentenced: 'Were you sentenced?',
        needmore: 'Since you answered yes we need more information',
        sentenceDescription: 'Provide a description of the sentence',
        exceedsYear: 'Were you sentenced to imprisonment for a term exceeding 1 year?',
        grantedParole: 'Were you granted parole or supervised release?',
        grantedParoleDates: 'What are or were the dates of your parole or supervised release?',
        incarcerated: 'Were you incarcerated as a result of that sentence for not less than 1 year?',
        incarcerationDates: 'You indicated you were imprisoned. When were you imprisoned?',
        incarcerationFacility: 'What is the name of the facility in which you were incarcerated? (Do not use acronyms)',
        incarcerationFacilityAddress: 'Is the facility in the U.S.?',
        probationDates: 'You indicated you were on probation. What are or were the dates of your probation?',
        awaitingTrial:
          'Are you currently on trial, awaiting a trial, or awaiting sentencing on criminal charges for this offense?',
        caseClosed: 'Is your case closed?',
        caseClosedDate: 'When was your case closed?',
        caseClosedStatusExplanation: 'Please explain.',
        courtOutcomeOnTrialExplanation: 'Please explain.',
        domesticExplanation: 'Please explain.',
        domesticOrderIssuedReason: 'Why was this order issued against you?',
        domesticOrderExpirationDate: 'What is the expiration date of the order?',
        domesticCourtName: 'Provide the name of the court or agency that issued the order',
        domesticCourtAddress: 'Is the court that issued this order in the U.S.?',
        domesticCourtDate: 'When was this order issued?',
        otherOffenseSentenced: 'Were you sentenced as a result of these charges?',
        protectedparty: 'Who is the protected party in the order?'
      },
      para: {
        intro1:
          'This section asks for information regarding your encounters with law enforcement and court systems, specifically any arrests, charges, convictions, or sentences you have had, as applicable.',
        intro2:
          '- Report applicable incidents (such as arrests, charges, etc.) that occurred in the U.S. or in a foreign country.  Foreign country means any geographic location not within the 50 U.S. states, District of Columbia, and U.S. territories.\n- Report charges filed in federal, state, local, tribal, or non-U.S. courts, as applicable.\n- Report information even if your record was expunged, sealed, or otherwise stricken from the court record. However, do not report convictions under the Federal Controlled Substances Act for which the court issued an expungement order under the authority of 21 U.S.C. 844 or 18 U.S.C. 3607.',
        intro3: '- Do not report crimes you listed in Section 9 (those you were charged with under the Uniform Code of Military Justice (UCMJ)).\n- Omit any violation of law committed before your 18th birthday if finally decided in juvenile court or appealed from juvenile court to a higher court and dismissed. ',
        intro1_orig:
          'For this section report information regardless of whether the record in your case has been sealed, expunged, or otherwise stricken from the court record, or the charge was dismissed.',
        intro2_orig:
          'You need not report convictions under the Federal Controlled Substances Act for which the court issued an expungement order under the authority of 21 U.S.C 844 or 18 U.S.C. 3607.',
        intro3_orig: '**Be sure to include all incidents whether occurring in the U.S. or abroad.**',
        chargeDetails:
          'Such as found guilty, found not-guilty, charge dropped or "nolle pros," etc. If you were found guilty of or pleaded guilty to lesser offense, list separately both the original charge and the lesser offense.',
        chargeDetailsContinuation: '',
        otherOffense: {
          intro:
            'Were you arrested for a crime  **in the past five years** but not charged ?',
          first:
            '**Have you EVER been convicted** in any court of the United States of a crime, sentenced to imprisonment for a term exceeding 1 year for that crime, and incarcerated as a result of that sentence for not less than 1 year? Include all qualifying convictions in Federal, state, local, or military court, even if previously listed on this form',
          second:
            '**Have you EVER been charged** with any felony offense? Include those under the Uniform Code of Military Justice and non-military/civilian offenses',
          third:
            '**Have you EVER been convicted** of an offense involving domestic violence or a crime of violence (such as battery or assault) against your child, dependent, cohabitant, spouse or legally recognized civil union/domestic partner, former spouse or legally recognized civil union/domestic partner, or someone with whom you share a child in common?',
          fourth: '**Have you EVER been charged** with an offense involving firearms or explosives?',
          fifth: '**Have you EVER been charged** with an offense involving alcohol or drugs?',
        },
        offenses1: 'For this section:',
        offenses2: 'This question asks for information regarding what are typically low-level civil or traffic violations or offenses (such as, jay walking, or running a red light) in which you have received a written notice from a law enforcement officer or other authorized official to appear in court or to pay a fine. These written notices include citations, summons, or tickets. This question differs from the next set of questions which will ask about offenses that rise to a higher level, such as misdemeanors, felonies, or their equivalents.',
        offenses3: 'These questions ask for information regarding offenses where you received a document listing criminal charges and to appear in criminal court. These documents are typically for offenses such as misdemeanors, felonies, or their equivalents.  The written documents could include citations, summons, tickets, complaints, arrest warrants, or indictments.',
        or: 'or',
      },
      label: {
        date: 'What is the date of the offense?',
        offenseLocation: 'Did this offense occur in the U.S.?',
        summons:
          'Have you received a citation, summons, ticket, or other similar written notice to appear in court or pay a fine  **in the past {{numberOfYearsString}}** ? (Answer “No” if it was for a traffic violation where the fine was under $1,000 and the offense did not involve alcohol or drugs.)',
        arrests:
          '**In the last {{numberOfYearsString}}** have you been arrested by any police officer, sheriff, marshal or any other type of law enforcement official?',
        charges:
          'Were you charged with, convicted of, or sentenced for a crime **in the past {{numberOfYearsString}}** ?',
        probation:
          'Have you been on probation **in the last {{numberOfYearsString}}** ? (Answer "Yes" even if your probation was part of a criminal sentence for a crime in which you were found guilty)',
        parole:
          'Have you been on parole or supervised release  **in the past {{numberOfYearsString}}** ? ',
        trial: 'Are you currently on trial or awaiting a trial on criminal charges?',
        violence:
          '**Domestic violence** -- is a crime of violence (such as battery or assault) against your parents or guardians; child; dependent; current or former spouse; current or former partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or someone with whom you share a child in common. This includes crimes that meet this definition even if the term “domestic violence” is not specifically used in the criminal charge or conviction. \n- Was domestic violence involved?',
        violenceConcise: '**Was domestic violence involved?**',
        county: 'County or County Equivalent',
        firearms: '**Were firearms involved?**',
        explosives: '**Were explosives involved?**',
        substances: '**Were drugs involved?**',
        alcohol: '**Was alcohol involved?**',
        facilityAddressUS: 'What is the address for this facility?',
        facilityAddressForeign: 'Where is this facility located?',
        agencyAddress: 'What is the address for this law enforcement agency?',
        agencyAddressForeign: 'Where is this law enforcement agency located?',
        address: 'What is this court\'s address?',
        addressoutsideus: 'Where is this court located?',
        explanation: 'Provide explanation',
        courtname: 'Name of court',
        felony: 'Felony',
        misdemeanor: 'Misdemeanor',
        other: 'Other',
        sentenceJudgements: 'What was your sentence?',
        sentenceJudgementOtherExplanation: 'Please explain "Other"',
        facilityAddress: 'Is the facilty in the U.S.?',
        checkAllParentheses: '(Check all that apply.)',
        offenseCourtFineNotPaidInFullExplanation: 'Please explain.',
        chargeTypeOtherExplanation: 'Please explain.',
        courtOutcomeOtherExplanation: 'Please explain.',
        courtOutcomeDismissedExplanation: 'Please explain.',
        courtOutcomeDismissedRequirements: 'What were the specific court requirements you had to complete before this charge was dismissed or disposed of? (Select all that apply)',
        courtRequirementsOtherExplanation: 'Please explain.',
        checkAll: 'Check all that apply',
        courtcharge: 'What is or was your charge? (If there is more than one charge for this offense, input one charge at a time. There will be an opportunity to input multiple entries.)',
        courtOutcome: 'What was the outcome for this charge?',
        courtAddressUS: 'What is the court\'s address?',
        courtAddressForeign: 'Where is this court located?',
        otherOffenseAddress: 'Where did it occur?',
        otherOffenseAddressUS: 'Where did it occur?',
        otherOffenseAddressForeign: 'Where did it occur?',
        domesticViolence:
          'Is there currently a domestic violence, restraining, protective, stay-away, no-contact, anti-harassment order, or similar order issued against you?',
        domesticViolenceAppend:
          'Do you have another domestic violence protective order or restraining order currently issued against you to report?',
        domesticViolenceSelectAll: '(Select all if more than one party.)',
        notApplicable: 'Not applicable',
      },
      help: {
        summons: {
          title: 'Need help with a summons, citation, or ticket?',
          message:
            'Answer "No" if all the citations involved traffic infractions where the fine was less than $300 and did not include alcohol or drugs.',
          note: '',
        },
        arrests: {
          title: 'Need help with an arrest?',
          message: 'If you were arrested answer "Yes" and provide the required information',
          note: '',
        },
        charges: {
          title: 'Need help with a criminal charge?',
          message:
            'Include all qualifying charges, convictions or sentences in any federal, state, local, military, or non-U.S. court, even if previously listed on this form.',
          note: '',
        },
        probation: {
          title: 'Need help with a current probation or parole?',
          message:
            'If you are currently on probation or parole answer "Yes" and provide the required information',
          note: '',
        },
        trial: {
          title: 'Need help if on or awaiting trial?',
          message:
            'If you currently awaiting or on trial please answer "Yes" and provide the required information',
          note: '',
        },
        date: {
          title: 'Tell us the date the actual offense happened',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        description: {
          title: 'Details about how this offense happened',
          message: 'Describe the offense to include what happened, who was involved, what the motivation was, and any other details. If domestic violence, firearms, explosives, drugs, or alcohol were involved in the offense, please explain.',
          note: '',
        },
        violence: {
          title: 'Need help if this offense involved violence?',
          message: 'Indicate if the offense involved domestic or criminal violence',
          note: '',
        },
        firearms: {
          title: 'Need help if this offense involved firearms or explosives?',
          message: 'Indicate if the offense involved firearms or explosives',
          note: '',
        },
        substances: {
          title: 'Need help if this offense involved alcohol or drugs?',
          message: 'Indicate if the offense involved alcohol or drugs',
          note: '',
        },
        address: {
          title: 'Need help with this address?',
          message: 'Tell us where the event happened.',
          note: '',
        },
        cited: {
          title: 'Need help if you were arrested, summoned, or cited for this offense?',
          message:
            'If you were arrested, summoned, or cited please answer "Yes" and provide the required information',
          note: '',
        },
        citedby: {
          title: 'Need help with the law enforcement agency name?',
          message: 'Provide the name of the law enforcement agency who handled this offense',
          note: '',
        },
        agencyaddress: {
          title: 'Try looking up the agency name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        charged: {
          title: 'Need help if you were charged, convicted, or awaiting trial?',
          message:
            'If you were charged, convicted, currently awaiting trial, or due to appear in court answer "Yes" and provide the required information',
          note: '',
        },
        courtname: {
          title: 'Need help with the name of the court?',
          message: 'Provide the name of the court',
          note: '',
        },
        courtaddress: {
          title: 'Try looking up the court name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        chargeType: {
          title: 'Need help with the type of charge?',
          message: 'Provide the type of charge issued by the court',
          note: '',
        },
        courtcharge: {
          title: 'Need help with the court charge(s)?',
          message: 'Provide the charge(s)',
          note: '',
        },
        courtoutcome: {
          title: 'Need help with the court outcome?',
          message: 'Provide the outcome of the court proceedings',
          note: '',
        },
        courtdate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        sentenced: {
          title: 'Need help if you were sentenced for this offense?',
          message:
            'If you were sentenced by the court for this offense please click "Yes" and provide the necessary information',
          note: '',
        },
        sentenceDescription: {
          title: 'Need help with the sentence description?',
          message: 'Provide a description of your sentencing',
          note: '',
        },
        exceedsYear: {
          title: 'Need help with this question?',
          message: 'Did this sentence include imprisonment and was the term of imprisonment for more than a year, if so, please mark "Yes".',
          note: 'If your sentence was more than 11 months and less than 12 and you were incarcerated and released in the same month (example January 2020 to January 2021), mark "Yes" and provide a comment in the description that it was less than a year',
        },
        incarcerated: {
          title: 'Need help with this question?',
          message: 'As a result of this sentence did you spend 1 or more years incarcerated (imprisoned or confined).',
          note: 'If you were incarcerated and released in the same month the following year but spent less than a year incarcerated (example January 2020 to January 2021), mark  "Yes" and provide a comment in the description that it was less than a year',
        },
        incarcerationDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        probationDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        awaitingTrial: {
          title: 'Need help with this question?',
          message:
            'Are you currently on trial, awaiting a trial, or awaiting sentencing on criminal charges for this offense?',
          note: '',
        },
        awaitingTrialExplanation: {
          title: 'Need help with awaiting trial explanation',
          message: 'Please explain',
          note: '',
        },
        otherConviction: {
          title: 'Need help with this conviction question?',
          message:
            'Include all qualifying convictions in Federal, state, local, or military court, even if previously listed on this form.',
          note: '',
        },
        otherFelony: {
          title: 'Need help with this charge question?',
          message:
            'Include those under the Uniform Code of Military Justice and non-military/civilian felony offenses.',
          note: '',
        },
        domesticExplanation: {
          title: 'Explain the order against you',
          message: 'Go into as much detail as you need to fully explain.',
          note: '',
        },
        domesticOrderIssuedReason: {
          title: 'Explain the order against you',
          message: 'Describe the circumstances that led to this order being issued',
          note: '',
        }
      },
      branchCollection: {
        domesticViolence: {
          title: 'Need help?',
          message:
            'Is there currently a domestic violence protective order or restraining order issued against you?',
        },
      },
      collection: {
        summary: {
          title: 'Summary of charges',
          item: 'Charge',
          unknown: 'Provide charge details below',
        },
        appendOtherOffense: 'Do you have another instance in which you were arrested for a crime in the past five years but not charged to report?',
        appendTitleContinuation: 'Do you have another charge for this offense to report?',
        appendTitle: [
          'Do you have another offense to report in the last {{years}} years pertaining to:',
          '- Receiving a citation, summons, ticket, or other similar written notice to appear in court or pay a fine in the past {{yearsString}} years? (Answer “No” if it was for a traffic violation where the fine was under $1,000 and the offense did not involve alcohol or drugs.)',
          '- Being charged with, convicted of, or sentenced for a crime.',
          '- Being on probation, parole or supervised release.'
        ],
        appendMessage: [
          '- Was domestic violence involved?',
          '- Were firearms involved?',
          '- Were explosives involved?',
          '- Were drugs involved?',
          '- Was alcolhol involved?',
        ],
        appendTitleOriginal: 'Do you have any other offenses where any of the following has happened to you?',
        appendMessageOriginal: [
          '- **In the last {{numberOfYearsString}}** have you been issued a summons, citation, or ticket to appear in court in a criminal proceeding against you? Do not check if all the citations involved traffic infractions where the fine was than $300 and did not include alcohol or drugs.',
          '- **In the last {{numberOfYearsString}}** have you been arrested by any police officer, sheriff, marshal or any other type of law enforcement official?',
          '- **In the last {{numberOfYearsString}}** have you been charged with, convicted of, or sentenced for a crime in any court? Include all qualifying charges, convictions or sentences in any federal, state, local, military, or non-U.S. court, even if previously listed on this form.',
          '- **In the last {{numberOfYearsString}}** have you been or are you currently on probation or parole?',
          '- Are you currently on trial or awaiting a trial on criminal charges?',
        ],
        append: 'Add another offense',
      },
    },
    associations: {
      label: {
        idk: 'I Don\'t Know',
      },
      terroristOrganizationMembership: {
        preambleLabel: 'PREAMBLE:\n ',
        preamble: 'The following pertains to your associations. You are required to answer the questions fully and truthfully, and your failure to do so could be  grounds for an adverse employment, security, or credentialing decision. Your truthful responses and any information derived from your  responses will not be used as evidence against you in a criminal proceeding.',
        purpose: 'For the purposes of this section:\n Advocacy is defined as: Attempting to persuade or incite others to act. It includes, but is not limited to, making calls, distributing flyers, \n fundraising, posting on social media, etc. with the intent to persuade or incite others to engage in acts or activities.\n ',
        terrorPurpose: 'Terrorism is defined as: Any activity that involves criminal acts dangerous to human life or potentially destructive of critical infrastructure, and appears to be intended to:',
        purposeBulletOne: 'Intimidate or coerce a civilian population; or',
        purposeBulletTwo: 'Influence the policy of a government by intimidation or coercion; or',
        purposeBulletThree: 'Affect the conduct of a government by mass destruction, assassination, or kidnapping',
        definition: 'Critical infrastructure is defined as: Assets, systems, and networks, whether physical or virtual, which are considered so vital to the United States that their incapacitation or destruction would have a debilitating effect on security, national economic security, national public health or safety, or any combination thereof.',
        hasTerroristOrganizationMembership: 'Have you ever been a member of an organization that, at the time of your membership, was both (i) dedicated to the use of violence or force to overthrow the United States Government or a State or tribal government of the United States, and (ii) engaged in activities to that end?',
        organization: 'What is the name of this organization? (Provide the full name without acronyms or abbreviations.)',
        usAddress: 'Does this organization have a physical address in the U.S.?',
        foreignAddress: 'Does this organization have a physical address outside of the U.S.?',
        whatAddress: 'What is the address?',
        hasWebpage: 'Does this organization have a web page?',
        webpage: 'What is the web page address?',
        dates: 'When were you a member of this organization?',
        reasonsForStaying: 'Why are you still a member of this organization?',
        reasonsForLeaving: 'Why did you stop being a member of this organization?',
        heldPositions: 'Did you hold any positions in this organization?',
        positionsHeld: 'What positions did you hold?',
        hasMadeContributions: 'Did you make any financial contributions to this organization?',
        contributionAmount: 'How much? (Approximate in U.S. dollars.)',
        awareOfViolence: 'Were you aware of this organization’s dedication to the use of violence or force to overthrow the United States Government or a State or tribal government of the United States?',
        intendedViolence: 'Were you a member of the organization with the intent to use violence or force to overthrow the United States Government or a State or tribal government of the United States?',
        useOfViolence: 'As a member, did you use violence or force with the intent to overthrow the United States Government or a State or tribal government of the United States?',
        reasonForJoining: 'Why did you become a member of this organization?',
        roleInOrg: 'What was your role in this organization? (Describe what you did, who you did it for, why you did it, where you did it, if others were involved, and any other details.)',
        pleaseExplain: 'Please explain.',
        reasons: 'Provide a description of the nature of and reasons for your involvement with the organization',
        collection: {
          description: 'Summary of terrorist organizations',
          item: 'Organization',
          unknown: 'Provide details of organization below',
          appendTitle: 'Do you have another instance in which you were a member of an organization that, at the time of your membership, was both (i) dedicated to the use of violence or force to overthrow the United States Government or a State or tribal government of the United States, and (ii) engaged in activities to that end to report?',
          appendLabel: 'Add another terrorist organization',
        },
        help: {
          organization: {
            title: 'Need help with this organization name?',
            message: 'Provide the name of the organization.',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      terrorismEngagement: {
        hasTerrorismEngagement: 'Have you ever knowingly engaged in activities designed to overthrow the United States Government, or a State or tribal government of the United States, by violence or force?',
        Why: 'Why did you knowingly engage in activities designed to overthrow the United StatesGovernment, or a State or tribal government of the United States, by violence or force?',
        When: 'When did you knowingly engage in activities designed to overthrow the United States Government, or a State or tribal government of the United States, by violence or force?',
        What: 'What activities did you knowingly engage in that were designed to overthrow the United StatesGovernment, or a State or tribal government of the United States, by violence or force? (Describe what you did, who you did it for, where you did it, if others were involved, and any other details.)',
        collection: {
          description: 'Summary of terrorist engagements',
          item: 'Engagement',
          unknown: 'Provide details of engagement below',
          appendTitle: 'Do you have another instance in which you knowingly engaged in activities designed to overthrow the United States Government, or a State or tribal government of the United States, by violence or force to report?',
          appendLabel: 'Add another terrorism engagement',
        },
        help: {
          when: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      terrorismAdvocacy: {
        hasTerrorismAdvocacy: 'Have you ever advocated any acts or activities designed to overthrow the United States Government or a State or tribal government of the United States, by violence or force?',
        Why: 'Why did you advocate activities designed to overthrow the United States Government, or a State or tribal government of the United States, by violence or force?',
        When: 'When did you advocate activities to overthrow the U.S. Government, or a State or tribal government of the United States, by violence or force?',
        What: 'What activities did you advocate designed to overthrow the United States Government, or a State or tribal government of the United States, by violence or force? (Describe what you did, who you did it for, where you did it, if others were involved, and any other details.)',
        collection: {
          description: 'Summary of terrorist advocacy',
          item: 'Advocacy',
          unknown: 'Provide details of advocacy below',
          appendTitle: 'Do you have another instance in which you advocated activities designed to overthrow the United States Government, or a State or tribal government of the United States, by violence or force to report?',
          appendLabel: 'Add another terrorism advocacy',
        },
        help: {
          when: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      rightsSuppressionGroup: {
        hasRightsSuppressionGroup: 'Have you ever been a member of an organization that, at the time of your membership, advocated for acts of force or violence to discourage others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        organization: 'What is the name of this organization? (Provide the full name without acronyms or abbreviations.)',
        usAddress: 'Does this organization have a physical address in the United States?',
        foreignAddress: 'Does this organization have a physical address outside of the U.S.?',
        whatAddress: 'What is the address? .',
        hasWebpage: 'Does this organization have a web page?',
        webpage: 'What is the web page address?',
        dates: 'When were you a member of this organization?',
        reasonsForStaying: 'Why are you still a member of this organization?',
        reasonsForLeaving: 'Why did you stop being a member of this organization?',
        heldPositions: 'Did you hold any positions in this organization?',
        positionsHeld: 'What positions did you hold?',
        hasMadeContributions: 'Did you make any financial contributions to this organization?',
        contributionAmount: 'How much? (Approximate in U.S. dollars.)',
        awareOfViolence: 'While you were a member, were you aware of the organization’s advocacy of acts of force or violence to discourage or prevent others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        intendedViolence: 'Did you join this organization or engage in activities as a member with the intent to advocate acts of force or violence to discourage or prevent others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        useOfViolence: 'As a member, did you advocate acts of force or violence to discourage or prevent others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        reasonForJoining: 'Why did you become a member of this organization?',
        roleInOrg: 'What was your role in this organization? (Describe what you did, who you did it for, why you did it, where you did it, if others were involved, and any other details.)',
        pleaseExplain: 'Please explain.',
        collection: {
          description: '',
          item: 'Rights Suppression Group',
          unknown: 'Provide details of rights suppression group below',
          appendTitle: 'Do you have another instance in which you were a member of an organization that, at the time of your membership, advocated for acts of force or violence to discourage or prevent others from exercising their rights under the United States Constitution or the constitution of any State of the United States to report?',
          appendLabel: 'Add another rights suppression group',
        },
        help: {
          organization: {
            title: 'Need help with this organization name?',
            message: 'Provide the name of the organization.',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      violentRightsSuppressionGroup: {
        hasViolentRightsSuppressionGroup: 'Have you ever been a member of an organization that at the time of your membership, engaged in acts of force or violence to discourage others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        organization: 'What is the name of this organization? (Provide the full name without acronyms or abbreviations.)',
        usAddress: 'Does this organization have a physical address in the United States?',
        foreignAddress: 'Does this organization have a physical address outside of the U.S.?',
        whatAddress: 'What is the address? ',
        hasWebpage: 'Does this organization have a web page?',
        webpage: 'What is the web page address?',
        dates: 'When were you a member of this organization?',
        reasonsForStaying: 'Why are you still a member of this organization?',
        reasonsForLeaving: 'Why did you stop being a member of this organization?',
        heldPositions: 'Did you hold any positions in this organization?',
        positionsHeld: 'What positions did you hold?',
        hasMadeContributions: 'Did you make any financial contributions to this organization?',
        contributionAmount: 'How much? (Approximate in U.S. dollars.)',
        awareOfViolence: 'At the time of your membership, were you aware the organization engaged in acts of force or violence to discourage others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        intendedViolence: 'Did you join the organization or engage in activities as a member with the intent to engage in acts of force or violence to discourage others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
        useOfViolence: 'As a member, did you engage in acts of force or violence to discourage or prevent others from exercising their rights under the United StatesConstitution or the constitution of any State of the United States?',
        reasonForJoining: 'Why did you become a member of this organization?',
        roleInOrg: 'What was your role in this organization? (Describe what you did, who you did it for, why you did it, where you did it, if others were involved, and any other details.)',
        pleaseExplain: 'Please explain.',
        collection: {
          description: '',
          item: 'Violent Rights Suppression Group',
          unknown: 'Provide details of violent rights suppression group below',
          appendTitle: 'Do you have another instance in which you were a member of an organization that, at the time of your membership, engaged in acts of force or violence to discourage others from exercising their rights under the United States Constitution or the constitution of any State of the United States?',
          appendLabel: 'Add another violent rights suppression group',
        },
        help: {
          organization: {
            title: 'Need help with this organization name?',
            message: 'Provide the name of the organization.',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      violentOrganization: {
        hasViolentOrganization: 'Are you now or have you ever been a member of an organization that, at the time of your membership, used unlawful force or violence?',
        organization: 'What is the name of this organization? (Provide the full name without acronyms or abbreviations.)',
        usAddress: 'Does this organization have a physical address in the United States?',
        foreignAddress: 'Does this organization have a physical address outside of the U.S.?',
        whatAddress: 'What is the address? ',
        hasWebpage: 'Does this organization have a web page?',
        webpage: 'What is the web page address?',
        dates: 'When were you a member of this organization?',
        reasonsForStaying: 'Why are you still a member of this organization?',
        reasonsForLeaving: 'Why did you stop being a member of this organization?',
        heldPositions: 'Did you hold any positions in this organization?',
        positionsHeld: 'What positions did you hold?',
        hasMadeContributions: 'Did you make any financial contributions to this organization?',
        contributionAmount: 'How much? (Approximate in U.S. dollars.)',
        useOfViolence: 'As a member, did you use unlawful force or violence?',
        reasonForJoining: 'Why did you become a member of this organization?',
        roleInOrg: 'What was your role in this organization? (Describe what you did, who you did it for, why you did it, where you did it, if others were involved, and any other details.)',
        pleaseExplain: 'Please explain.',
        collection: {
          description: '',
          item: 'Violent Organization',
          unknown: 'Provide details of violent organization below',
          appendTitle: 'Do you have another instance in which you were a member of an organization that, at the time of your membership, used unlawful force or violence?',
          appendLabel: 'Add another violent organization',
        },
        help: {
          organization: {
            title: 'Need help with this organization name?',
            message: 'Provide the name of the organization.',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      violentActs: {
        hasViolentAct: 'Have you ever planned, contributed to, attempted, or carried out an unlawful act of force or violence targeted at a person, group of people, or property?',
        wasGovermentOfficial: 'Was the target an official of the United States Government or the government of a State, local, or tribal government of the United States?',
        govermentOfficial: {
          Why: 'Why did you target this government official?',
          When: 'When did you target this government official?',
          What: 'What did you do? (Describe how you planned, contributed to, attempted, or carried out this unlawful act of force or violence; who you did it for; where you did it; if others were involved; and any other details.)',
        },
        wasGovermentOfficialAppend: 'Do you have another instance in which you targeted an official of the United States Government or the Government of a State, local, or tribal government of the United States?',
        wasHateCrime: 'Was the target an individual or individuals based on their race, color, religion, sex, national origin, age, disability, genetic information, or pregnancy?',
        hateCrime: {
          Why: 'Why did you target this individual or individuals?',
          When: 'When did you target this individual or individuals?',
          What: 'What did you do? (Describe how you planned, contributed to, attempted, or carried out this unlawful act of force or violence; who you did it for; where you did it; if others were involved; and any other details.)',
        },
        wasHateCrimeAppend: 'Do you have another instance in which you targeted an individual or individuals based on their race, color, religion, sex, national origin, age, disability, genetic information, or pregnancy?',
        wasGovernmentProperty: 'Was the target property of the United States Government or the government of a State, local or tribal government of the United States?',
        governmentProperty: {
          Was: 'Was this property critical infrastructure?',
          Why: 'Why did you target this property?',
          When: 'When did you target this property?',
          What: 'What did you do? (Describe how you planned, contributed to, attempted, or carried out this unlawful act of force or violence; who you did it for; where you did it; if others were involved; and any other details.)',
        },
        wasGovernmentPropertyAppend: 'Do you have another instance in which you targeted property of the United States Government or the Government of a State, local or tribal government of the United States?',
      },
      hateCrimeAdvocacy: {
        hasHateCrimeAdvocacy: 'Have you ever advocated unlawful acts of violence against individuals based on their race, color, religion, sex, national origin, age, disability, genetic information, or pregnancy?',
        Why: 'Why did you advocate unlawful acts of violence against this individual or individuals?',
        When: 'When did you advocate unlawful acts of violence against this individual or individuals?',
        What: 'What did you do? (Describe what you did, who you did it for, where you did it, if others were involved, and any other details.)',
        collection: {
          description: 'Summary of hate crime advocacy',
          item: 'Advocacy',
          unknown: 'Provide details of advocacy below',
          appendTitle: 'Do you have another instance in which you advocated unlawful acts of violence against an individual or individuals based on their race, color, religion, sex, national origin, age, disability, genetic information, or pregnancy?',
          appendLabel: 'Add another hate crime advocacy',
        },
        help: {
          when: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      internationalAndDomesticTerrorism: {
        hasInternationalAndDomesticTerrorism: 'Are you now or have you ever been a member of an organization dedicated to domestic or international terrorism?',
        organization: 'What is the name of this organization? (Provide the full name without acronyms or abbreviations.)',
        usAddress: 'Does this organization have a physical address in the United States?',
        foreignAddress: 'Does this organization have a physical address outside of the U.S.?',
        whatAddress: 'What is the address? ',
        hasWebpage: 'Does this organization have a web page?',
        webpage: 'What is the web page address?',
        dates: 'When were you a member of this organization?',
        reasonsForStaying: 'Why are you still a member of this organization?',
        reasonsForLeaving: 'Why did you stop being a member of this organization?',
        heldPositions: 'Did you hold any positions in this organization?',
        positionsHeld: 'What positions did you hold?',
        hasMadeContributions: 'Did you make any financial contributions to this organization?',
        contributionAmount: 'How much? (Approximate in U.S. dollars.)',
        awareOfViolence: 'At the time you were a member, were you aware of the organization’s dedication to domestic or international terrorism?',
        intendedViolence: 'Were you a member of this organization or engage in activities as a member with the intent to further acts of domestic or international terrorism?',
        useOfViolence: 'Did you intentionally engage in acts of domestic or international terrorism?',
        reasonForJoining: 'Why did you become a member of this organization?',
        roleInOrg: 'What was your role in this organization? (Describe what you did, who you did it for, why you did it, where you did it, if others were involved, and any other details.)',
        pleaseExplain: 'Please explain.',
        collection: {
          description: '',
          item: 'international and domestic terrorism',
          unknown: 'Provide details of international or domestic terrorism below',
          appendTitle: 'Do you have another instance in which you were a member of an organization that, at the time of your membership, was dedicated to domestic or international terrorism?',
          appendLabel: 'Add another international or domestic terrorism organization',
        },
        help: {
          organization: {
            title: 'Need help with this organization name?',
            message: 'Provide the name of the organization.',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      internationalAndDomesticTerrorismEngagement: {
        hasInternationalAndDomesticTerrorismEngagement: 'Have you ever knowingly engaged in any acts of domestic or international terrorism?',
        Why: 'Why did you engage in these activities of domestic or international terrorism?',
        When: 'When did you engage in these activities of domestic or international terrorism?',
        What: 'What acts of domestic or international terrorism did you engage in? (Describe what you did, who you did it for, why you did it, where you did it, and any other details.)',
        collection: {
          description: 'Summary of international or domestic terrorism engagement',
          item: 'Terrorism',
          unknown: 'Provide details of international or domestic terrorism engagement below',
          appendTitle: 'Do you have another instance in which you engaged in acts of domestic or international terrorism?',
          appendLabel: 'Add another international or domestic terrorism engagement',
        },
        help: {
          when: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      internationalAndDomesticTerrorismAssociation: {
        hasInternationalAndDomesticTerrorismAssociation: 'Have you ever knowingly associated with anyone involved in activities to further domestic or international terrorism?',
        When: 'When did you associate with this individual?',
        WhyStill: 'Why do you still associate with this individual?',
        WhyStop: 'Why did you stop associating with this individual?',
        What: 'What is or was your relationship with this individual? (Describe how you met, how often you are or were in contact, what activities you did together, whether this individual has any leverage over you, and any other details.)',
        collection: {
          description: 'Summary of international or domestic terrorism association',
          item: 'Association',
          unknown: 'Provide details of international or domestic terrorism association below',
          appendTitle: 'Do you have another instance in which you knowingly associated with an individual involved in activities to further domestic or international terrorism?',
          appendLabel: 'Add another international or domestic terrorism association',
        },
        help: {
          when: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      internationalAndDomesticTerrorismAdvocacy: {
        hasInternationalAndDomesticTerrorismAdvocacy: 'Have you ever advocated any acts of domestic or international terrorism?',
        Why: 'Why did you advocate these activities of domestic or international terrorism?',
        When: 'When did you advocate these activities of domestic or international terrorism?',
        What: 'What acts of domestic or international terrorism did you advocate? (Describe what you did, who you did it for, why you did it, where you did it, and any other details.)',
        collection: {
          description: 'Summary of international or domestic terrorism advocacy',
          item: 'Advocacy',
          unknown: 'Provide details of international or domestic advocacy below',
          appendTitle: 'Do you have another instance in which you advocated acts of domestic or international terrorism?',
          appendLabel: 'Add another international or domestic terrorism advocacy',
        },
        help: {
          when: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
    },
    technology: {
      intro: {
        bullet: 'This section asks for information regarding your use of information technology (IT) systems.',
        bullet1: 'For this section:',
        bulletone: 'IT systems include all related computer hardware, software, firmware, and data used for the communication, transmission, processing, manipulation, storage, or protection of information. ',
        bullettwo: 'The term "illegal" applies whether or not you were arrested, charged, or convicted of a crime. ',
        bulletthree: 'Your truthful responses and any information derived from your responses will not be used as evidence against you in a subsequent criminal proceeding. This applies whether or not you are employed by the Federal Government. ',
        bulletfour: 'Do NOT include classified information or any specifics regarding other protected information or classified IT systems in any of your responses.',
      },
      unauthorized: {
        heading: {
          title:
            'Have you illegally or without proper authorization accessed or tried to access any IT system in the past five years?',
          date: 'When did you illegally or without proper authorization access or try to access an IT system?',
          incidentplace: 'From what location did you illegally or without proper authorization access or try to access this IT system? (Select all that apply.)',
          incident: 'Provide a description of the nature of the incident or offense',
          location: 'Provide the location where the incident took place',
          inUS: 'Is this location in the U.S.?',
          action:
            'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
          usaddress: 'What is the address?',
          nonusaddress: 'Where is this located?',
          idk: 'I dont know',
          or: 'or',
          infotype: 'What type of information did you access?',
          systemname: 'What is the name of the IT system you illegally or without proper authorization accessed or tried to access? ',
          systemowner: 'What is the name of the agency, organization, entity, or individual that owned or operated this IT system?',
          systemsuccess: 'Did you succeed in accessing this IT system illegally or without proper authorization?',
          systeminfo: 'What type of information did you access?',
          systemtimes: 'How many times did you access this IT system?',
          systemshare: 'Did you share any of the information you accessed with anyone? ',
          systemwho: 'Who?',
          systemoccurances: 'How many times did you try to access this IT system? ',
          systemwhy: 'Why did you illegally or without proper authorization access or try to access this IT system?',
          systemget: 'Did you receive any of the following actions for accessing or trying to access this IT system illegally or without proper authorization?',
          actiondetails: 'Provide details. (Include a description of the action taken against you, who took this action, when you received this action, where you received this action, and any other details.)',
          repeat: 'Do you have another instance in which you illegally or without proper authorization accessed an IT system or tried to in the past five years?',
        },

        para: {
          intro: [
            'We note, with reference to this section, that neither your truthful responses nor information derived from your responses to this section will be used as evidence against you in a subsequent criminal proceeding.',
            'As to this particular section, this applies whether or not you are currently employed by the Federal government. The following questions ask about your use of information technology systems. Information technology systems include all related computer hardware, software, firmware, and data used for the communication, transmission, processing, manipulation, storage or protection of information.',
          ],
          checkall: 'Select all that apply',
          explain: 'Please explain.',
        },
        place: {
          home: 'Home Address',
          work: 'Work Address',
          other: 'Other',
        },
        actions: {
          action1: 'Workplace disciplinary or administrative actions.',
          action2: 'Civil actions',
          action3: 'Criminal actions',
          action4: 'Other',
          action5: 'No actions taken',
          action6: 'Security Violation or Infraction',

        },
        collection: {
          appendTitle: 'Do you have another instance in which you illegally or without proper authorization accessed an IT system or tried to in the past five years?',
        },
      },
      manipulating: {
        heading: {
          title: 'Have you illegally or without proper authorization modified, destroyed, or manipulated information on an IT system or tried to in the past five years?',
          date: 'When did you illegally or without proper authorization modify, destroy, or manipulate  information on an IT system or try to?',
          incidentplace: 'From what location did you illegally or without proper authorization modify, destroy or manipulate information on an IT system or try to? (Select all that apply.)',
          incident: 'Provide a description of the nature of the incident or offense',
          location: 'Provide the location where the incident took place',
          inUS: 'Is this location in the U.S.?',
          action:
            'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
          usaddress: 'What is the address?',
          nonusaddress: 'Where is this located?',
          idk: 'I dont know',
          or: 'or',
          infotype: 'What type of information did you modify, destroy or manipulate?',
          systemname: 'What is the name of the IT system you illegally or without proper authorization changed or destroyed information on or tried to? ',
          systemowner: 'What is the name of the agency, organization, entity, or individual that owned or operated this IT system?',
          systemsuccess: 'Did you succeed in modifying, destroying, or manipulating information on this IT system illegally or without proper authorization?',
          systeminfo: 'What type of information did you modify, destroy or manipulate?',
          systemtimes: 'How many times did you modify, destroy, or manipulate information on this IT system illegally or without proper authorization?',
          systemshare: 'Did you share any of the information you accessed with anyone? ',
          systemwho: 'Who?',
          systemoccurances: 'How many times did you try to modify, destroy, or manipulate information on this IT system illegally or without proper authorization? ',
          systemwhy: 'Why did you illegally or without proper authorization modify, destroy, or manipulate information on this IT system or try to?',
          systemget: 'Did you receive any of the following actions for modifying, destroying, or manipulating information on this IT system or trying to illegally or without proper authorization? (Select all that apply.)',
          actiondetails: 'Provide details. (Include a description of the action taken against you, who took this action, when you received this action, where you received this action, and any other details.)',
          repeat: 'Do you have another instance in which you illegally or without proper authorization changed or destroyed information on an IT system or tried to in the past five years?',
        },
        para: {
          intro: [
            'We note, with reference to this section, that neither your truthful responses nor information derived from your responses to this section will be used as evidence against you in a subsequent criminal proceeding.',
            'As to this particular section, this applies whether or not you are currently employed by the Federal government. The following questions ask about your use of information technology systems. Information technology systems include all related computer hardware, software, firmware, and data used for the communication, transmission, processing, manipulation, storage or protection of information.',
          ],
          checkall: 'Select all that apply',
          explain: 'Please explain.',
        },
        place: {
          home: 'Home Address',
          work: 'Work Address',
          other: 'Other',
        },
        actions: {
          action1: 'Workplace disciplinary or administrative actions.',
          action2: 'Civil actions',
          action3: 'Criminal actions',
          action4: 'Other',
          action5: 'No actions taken',
          action6: 'Security Violation or Infraction',

        },
        collection: {
          appendTitle: 'Do you have another instance in which you illegally or without proper authorization changed or destroyed information on an IT system or tried to in the past five years?',
        },
      },
      denied: {
        heading: {
          title: 'Have you illegally or without proper authorization denied others access to information on an IT system or tried to in the past five years?',
          date: 'When did you illegally or without proper authorization deny others access to information on an IT system or try to?',
          incidentplace: 'From what location did you illegally or without proper authorization deny others access to information on an IT system or try to? (Select all that apply.)',
          incident: 'Provide a description of the nature of the incident or offense',
          location: 'Provide the location where the incident took place',
          inUS: 'Is this location in the U.S.?',
          action:
            'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
          usaddress: 'What is the address?',
          nonusaddress: 'Where is this located?',
          idk: 'I dont know',
          or: 'or',
          infotype: 'What type of information did you modify, destroy or manipulate?',
          systemname: 'What is the name of the IT system you illegally or without proper authorization denied others access to information on or tried to deny others access to information on?',
          systemowner: 'What is the name of the agency, organization, entity, or individual that owned or operated this IT system?',
          systemsuccess: 'Did you succeed in denying others access to information on this IT system illegally or without proper authorization?',
          systeminfo: 'What type of information did you deny others access to?',
          systemtimes: 'How many times did you deny others access to information on this IT system?',
          systemshare: 'Did you share any of the information you accessed with anyone? ',
          systemwho: 'Who?',
          systemoccurances: 'How many times did you try to deny others access to information on this IT system? ',
          systemwhy: 'Why did you illegally or without proper authorization deny others access to information on this IT system or try to?',
          systemget: 'Did you receive any of the following actions for denying others access to information on this IT system or trying to illegally or without proper authorization? (Select all that apply.)',
          actiondetails: 'Provide details. (Include a description of the action taken against you, who took this action, when you received this action, where you received this action, and any other details.)',
          repeat: 'Do you have another instance in which you illegally or without proper authorization denied others access to information on an IT system or tried to in the past five years?',
        },
        para: {
          checkall: 'Select all that apply',
          explain: 'Please explain.',
        },
        place: {
          home: 'Home Address',
          work: 'Work Address',
          other: 'Other',
        },
        collection: {
          description: 'Summary of denied use',
          item: 'Use',
          unknown: 'Provide details below',
          appendTitle: 'Do you have another instance in which you illegally or without proper authorization denied others access to information on an IT system or tried to in the past five years?',
          appendLabel: 'Add another denied use',
        },
        actions: {
          action1: 'Workplace disciplinary or administrative actions.',
          action2: 'Civil actions',
          action3: 'Criminal actions',
          action4: 'Other',
          action5: 'No actions taken',
          action6: 'Security Violation or Infraction',

        },

      },
      unlawful: {
        heading: {
          title: 'Have you illegally or without proper authorization introduced, used, or removed hardware, software, or media from an IT system or tried to in the past five years?',
          date: 'When did you illegally or without proper authorization introduce, use, or remove hardware, software, or media from an IT system or try to?',
          incidentplace: 'From what location did you illegally or without proper authorization introduce, use, or remove hardware, software, or media from an IT system or try to? (Select all that apply.)',
          incident: 'Provide a description of the nature of the incident or offense',
          location: 'Provide the location where the incident took place',
          inUS: 'Is this location in the U.S.?',
          action:
            'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
          usaddress: 'What is the address?',
          nonusaddress: 'Where is this located?',
          idk: 'I dont know',
          or: 'or',
          infotype: 'What type of information did you modify, destroy or manipulate?',
          systemname: 'What is the name of the IT system you illegally or without proper authorization introduced, used, or removed hardware, software, or media from or tried to?',
          systemowner: 'What is the name of the agency, organization, entity, or individual that owned or operated this IT system?',
          systemsuccess: 'Did you succeed in introducing, using, or removing hardware, software, or media from an IT system illegally or without proper authorization?',
          systeminfo: 'What type of information did you deny others access to?',
          systemtimes: 'How many times did you introduce, use, or remove hardware, software, or media from this IT system?',
          systemshare: 'Did you share any of the information you accessed with anyone? ',
          systemwho: 'Who?',
          systemwhy: 'Why did you illegally or without proper authorization introduce, use, or remove hardware, software, or media from this IT system or try to?',
          systemget: 'Did you receive any of the following actions for introducing, using, or removing hardware, software, or media from this IT system or trying to illegally or without proper authorization? (Select all that apply.)',
          actiondetails: 'Provide details. (Include a description of the action taken against you, who took this action, when you received this action, where you received this action, and any other details.)',
          repeat: 'Do you have another instance in which you illegally or without proper authorization introduced, used, or removed hardware, software, or media from an IT system or tried to in the past five years?',
        },
        para: {
          checkall: 'Select all that apply',
          explain: 'Please explain.',
        },
        place: {
          home: 'Home Address',
          work: 'Work Address',
          other: 'Other',
        },
        actions: {
          action1: 'Workplace disciplinary or administrative actions.',
          action2: 'Civil actions',
          action3: 'Criminal actions',
          action4: 'Other',
          action5: 'No actions taken',
          action6: 'Security Violation or Infraction',

        },
        collection: {
          appendTitle: 'Do you have another instance in which you illegally or without proper authorization introduced, used, or removed hardware, software, or media from an IT system or tried to in the past five years?',
        }
      }

    }
  },

  intro: {
    title: 'Investigative and criminal history',
    body:
      'You will be asked questions about your investigative and criminal background and be asked to provide details if necessary.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with investigative & criminal history at once',
  },
  section: {
    name: 'Investigative and criminal history',
  },
  subsection: {
    intro: 'Introduction',
    police: {
      label: 'Police record',
      intro: 'Introduction',
      offenses: 'Offenses',
      additionalOffenses: 'Additional offenses',
      domesticViolence: 'Domestic violence',
      record: 'Police Record',
    },
    investigations: {
      label: 'Investigations and clearance record',
      history: 'Ever been investigated',
      clearanceissues: 'Clearance issues',
      piv: 'Personal Identity Verification issues',
      revoked: 'Denied',
      debarred: 'Debarment',
      foreign: 'Foreign investigations'
    },
    court: 'Involvement in non-criminal court actions',
    technology: {
      label: 'Use of information technology systems',
      unauthorized: 'Unauthorized access',
      manipulating: 'Manipulating access',
      unlawful: 'Unlawful use',
    },
    associations: {
      label: 'Association record',
      terroristOrganization: 'Terrorist organization',
      engagedTerrorism: 'Engaged in terrorism',
      advocating: 'Advocating',
      overthrow: 'Membership - overthrow',
      violence: 'Membership - violence or force',
      activitiesOverthrow: 'Activities to overthrow',
      terrorismAssociation: 'Terrorism association',
    },
    review: 'Review',
  },
  destination: {
    intro: 'Investigative and criminal history intro',
    'police/intro': 'Police record',
    'police/offenses': 'Offenses',
    'police/policerecord': 'Police Record',
    'police/additionaloffenses': 'Additional offenses',
    'police/domesticviolence': 'Domestic violence',
    court: 'Non-criminal court actions',
    criminalConvictions: 'Criminal Convictions Resulting in Sentences Over One Year',
    'investigations/intro': 'U.S. personnel vetting investigations, security clearances, and federal debarments',
    'investigations/history': 'Ever been investigated',
    'investigations/clearanceissues': 'Clearance issues',
    'investigations/revoked': 'Denied',
    'investigations/pivissues': 'Personal identity verification issues',
    'investigations/debarred': 'Debarment',
    'investigations/foreign': 'Foreign investigations',
    'technology/intro': 'Introduction',
    'technologyprotected/intro': 'Introduction',
    'technologyprotected/protectedunauthorized': 'Unauthorized access',
    'technologyprotected/noncompliance': 'Non-compliance incidents',
    'technology/unauthorized': 'Unauthorized access',
    'technology/manipulating': 'Manipulating access',
    'technology/denied': 'Denied use',
    'technology/unlawful': 'Unlawful use',
    'associations/terrorist-organization': 'Terrorist organization',
    'associations/engaged-in-terrorism': 'Engaged in terrorism',
    'associations/advocating': 'Advocating',
    'associations/membership-overthrow': 'Membership - overthrow',
    'associations/membership-violence-or-force': 'Membership - violence or force',
    'associations/activities-to-overthrow': 'Activities to overthrow',
    'associations/terrorism-association': 'Terrorism association',
    'associations/terrorist-organization-membership': 'Terrorist organization membership',
    'associations/terrorism-engagement': 'Terrorism Engagement',
    'associations/terrorism-advocacy': 'Terrorism Advocacy',
    'associations/rights-suppression-group': 'Rights Suppression Group',
    'associations/violent-rights-suppression-group': 'Violent Rights Suppression Group',
    'associations/violent-organization': 'Violent Organization',
    'associations/violent-acts': 'Violent Acts',
    'associations/hate-crime-advocacy': 'Hate Crime Advocacy',
    'associations/international-and-domestic-terrorism': 'International And Domestic Terrorism',
    'associations/international-and-domestic-terrorism-engagement': 'International And Domestic Terrorism Engagement',
    'associations/international-and-domestic-terrorism-association': 'International And Domestic Terrorism Association',
    'associations/international-and-domestic-terrorism-advocacy': 'International And Domestic Terrorism Advocacy',

    review: 'Review investigative & criminal history',
  },
  police: {
    heading: {
      title: 'Police record',
      questions: 'Have any of the following happened?',
      date: 'Provide the date of the offense',
      description: 'Provide a description of the specific nature of the offense',
      involvement: 'Did this offense involve any of the following?',
      address: 'Provide the location where the offense occurred',
      cited:
        'Were you arrested, summoned, cited, or did you receive a ticket to appear as a result of this offense by any police officer, sheriff, marshal or any other type of law enforcement official?',
      citedagency: 'Arresting/citing/summoning agency',
      citedby: 'Provide the name of the law enforcement agency that arrested/cited/summoned you.',
      agencyaddress: 'Provide the location of the law enforcement agency',
      charged:
        'As a result of this offense were you charged, convicted, currently awaiting trial, and/or ordered to appear in court in a criminal proceeding against you?',
      courtinfo: 'Court Information',
      courtname: 'Provide the name of the court',
      courtaddress: 'Provide the location of the court',
      chargedetails:
        'Provide all the charges brought against you for this offense, and the outcome of each charged offense',
      chargeType: 'Type of charge',
      courtdate: 'Date',
      sentenced: 'Were you sentenced as a result of this offense?',
      needmore: 'Since you answered yes we need more information',
      sentenceDescription: 'Provide a description of the sentence',
      exceedsYear: 'Were you sentenced to imprisonment for a term exceeding 1 year?',
      incarcerated: 'Were you incarcerated as a result of that sentence for not less than 1 year?',
      incarcerationDates:
        'If the conviction resulted in imprisonment, provide the dates that you actually were incarcerated',
      probationDates:
        'If conviction resulted in probation or parole, provide the  dates of probation or parole',
      awaitingTrial:
        'Are you currently on trial, awaiting a trial, or awaiting sentencing on criminal charges for this offense?',
      awaitingTrialExplanation: 'Provide explanation',
      domesticExplanation: 'Provide explanation',
      domesticCourtName: 'Provide the name of the court or agency that issued the order',
      domesticCourtAddress: 'Provide the location of the court or agency that issued the order',
      domesticCourtDate: 'Provide the date the order was issued',
      otherOffenseSentenced: 'Were you sentenced as a result of these charges?',
    },
    para: {
      intro1:
        'For this section report information regardless of whether the record in your case has been sealed, expunged, or otherwise stricken from the court record, or the charge was dismissed.',
      intro2:
        'You need not report convictions under the Federal Controlled Substances Act for which the court issued an expungement order under the authority of 21 U.S.C 844 or 18 U.S.C. 3607.',
      intro3: '**Be sure to include all incidents whether occurring in the U.S. or abroad.**',
      chargedetails:
        'Such as found guilty, found not-guilty, charge dropped or "nolle pros," etc. If you were found guilty of or pleaded guilty to lesser offense, list separately both the original charge and the lesser offense.',
      otherOffense: {
        intro:
          'Other than those offenses already listed, have you EVER had the following happen to you?',
        first:
          '**Have you EVER been convicted** in any court of the United States of a crime, sentenced to imprisonment for a term exceeding 1 year for that crime, and incarcerated as a result of that sentence for not less than 1 year? Include all qualifying convictions in Federal, state, local, or military court, even if previously listed on this form',
        second:
          '**Have you EVER been charged** with any felony offense? Include those under the Uniform Code of Military Justice and non-military/civilian offenses',
        third:
          '**Have you EVER been convicted** of an offense involving domestic violence or a crime of violence (such as battery or assault) against your child, dependent, cohabitant, spouse or legally recognized civil union/domestic partner, former spouse or legally recognized civil union/domestic partner, or someone with whom you share a child in common?',
        fourth: '**Have you EVER been charged** with an offense involving firearms or explosives?',
        fifth: '**Have you EVER been charged** with an offense involving alcohol or drugs?',
      },
      or: 'or',
    },
    label: {
      summons:
        '**In the last {{numberOfYearsString}}** have you been issued a summons, citation, or ticket to appear in court in a criminal proceeding against you? Do not check if all the citations involved traffic infractions where the fine was less than $300 and did not include alcohol or drugs.',
      arrests:
        '**In the last {{numberOfYearsString}}** have you been arrested by any police officer, sheriff, marshal or any other type of law enforcement official?',
      charges:
        '**In the last {{numberOfYearsString}}** have you been charged with, convicted of, or sentenced for a crime in any court? Include all qualifying charges, convictions or sentences in any federal, state, local, military, or non-U.S. court, even if previously listed on this form.',
      probation:
        '**In the last {{numberOfYearsString}}** have you been or are you currently on probation or parole?',
      trial: 'Are you currently on trial or awaiting a trial on criminal charges?',
      violence:
        '**Domestic violence or a crime of violence** (such as battery or assault) against your child, dependent, cohabitant, spouse or legally recognized civil union/domestic partner, former spouse or legally recognized civil union/domestic partner, or someone with whom you share a child in common?',
      firearms: '**Involve firearms or explosives?**',
      substances: '**Involve alcohol or drugs?**',
      address: 'This address is',
      explanation: 'Provide explanation',
      courtname: 'Name of court',
      felony: 'Felony',
      misdemeanor: 'Misdemeanor',
      other: 'Other',
      courtcharge: 'Charge',
      courtoutcome: 'Outcome',
      domesticViolence:
        'Is there currently a domestic violence protective order or restraining order issued against you?',
      domesticViolenceAppend:
        'Do you have another domestic violence protective order or restraining order currently issued against you to report?',
      notApplicable: 'Not applicable',
    },
    help: {
      summons: {
        title: 'Need help with a summons, citation, or ticket?',
        message:
          'Answer "No" if all the citations involved traffic infractions where the fine was less than $300 and did not include alcohol or drugs.',
        note: '',
      },
      arrests: {
        title: 'Need help with an arrest?',
        message: 'If you were arrested answer "Yes" and provide the required information',
        note: '',
      },
      charges: {
        title: 'Need help with a criminal charge?',
        message:
          'Include all qualifying charges, convictions or sentences in any federal, state, local, military, or non-U.S. court, even if previously listed on this form.',
        note: '',
      },
      probation: {
        title: 'Need help with a current probation or parole?',
        message:
          'If you are currently on probation or parole answer "Yes" and provide the required information',
        note: '',
      },
      trial: {
        title: 'Need help if on or awaiting trial?',
        message:
          'If you currently awaiting or on trial please answer "Yes" and provide the required information',
        note: '',
      },
      date: {
        title: 'Tell us the date the actual offense happened',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      description: {
        title: 'Details about how this offense happened',
        message: 'Be as clear and in depth as you can.',
        note: '',
      },
      violence: {
        title: 'Need help if this offense involved violence?',
        message: 'Indicate if the offense involved domestic or criminal violence',
        note: '',
      },
      firearms: {
        title: 'Need help if this offense involved firearms or explosives?',
        message: 'Indicate if the offense involved firearms or explosives',
        note: '',
      },
      substances: {
        title: 'Need help if this offense involved alcohol or drugs?',
        message: 'Indicate if the offense involved alcohol or drugs',
        note: '',
      },
      address: {
        title: 'Need help with this address?',
        message: 'Tell us where the event happened.',
        note: '',
      },
      cited: {
        title: 'Need help if you were arrested, summoned, or cited for this offense?',
        message:
          'If you were arrested, summoned, or cited please answer "Yes" and provide the required information',
        note: '',
      },
      citedby: {
        title: 'Need help with the law enforcement agency name?',
        message: 'Provide the name of the law enforcement agency who handled this offense',
        note: '',
      },
      agencyaddress: {
        title: 'Try looking up the agency name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      charged: {
        title: 'Need help if you were charged, convicted, or awaiting trial?',
        message:
          'If you were charged, convicted, currently awaiting trial, or due to appear in court answer "Yes" and provide the required information',
        note: '',
      },
      courtname: {
        title: 'Need help with the name of the court?',
        message: 'Provide the name of the court',
        note: '',
      },
      courtaddress: {
        title: 'Try looking up the court name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      chargeType: {
        title: 'Need help with the type of charge?',
        message: 'Provide the type of charge issued by the court',
        note: '',
      },
      courtcharge: {
        title: 'Need help with the court charge(s)?',
        message: 'Provide the charge(s)',
        note: '',
      },
      courtoutcome: {
        title: 'Need help with the court outcome?',
        message: 'Provide the outcome of the court proceedings',
        note: '',
      },
      courtdate: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      sentenced: {
        title: 'Need help if you were sentenced for this offense?',
        message:
          'If you were sentenced by the court for this offense please click "Yes" and provide the necessary information',
        note: '',
      },
      sentenceDescription: {
        title: 'Need help with the sentence description?',
        message: 'Provide a description of your sentencing',
        note: '',
      },
      exceedsYear: {
        title: 'Need help with this question?',
        message: 'Did this sentence include imprisonment and was the term of imprisonment for more than a year, if so, please mark "Yes".',
        note: 'If your sentence was more than 11 months and less than 12 and you were incarcerated and released in the same month (example January 2020 to January 2021), mark "Yes" and provide a comment in the description that it was less than a year',
      },
      incarcerated: {
        title: 'Need help with this question?',
        message: 'As a result of this sentence did you spend 1 or more years incarcerated (imprisoned or confined).',
        note: 'If you were incarcerated and released in the same month the following year but spent less than a year incarcerated (example January 2020 to January 2021), mark  "Yes" and provide a comment in the description that it was less than a year',
      },
      incarcerationDates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      probationDates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      awaitingTrial: {
        title: 'Need help with this question?',
        message:
          'Are you currently on trial, awaiting a trial, or awaiting sentencing on criminal charges for this offense?',
        note: '',
      },
      awaitingTrialExplanation: {
        title: 'Need help with awaiting trial explanation',
        message: 'Provide explanation',
        note: '',
      },
      otherConviction: {
        title: 'Need help with this conviction question?',
        message:
          'Include all qualifying convictions in Federal, state, local, or military court, even if previously listed on this form.',
        note: '',
      },
      otherFelony: {
        title: 'Need help with this charge question?',
        message:
          'Include those under the Uniform Code of Military Justice and non-military/civilian felony offenses.',
        note: '',
      },
      domesticExplanation: {
        title: 'Explain the order against you',
        message: 'Go into as much detail as you need to fully explain.',
        note: '',
      },
    },
    branchCollection: {
      domesticViolence: {
        title: 'Need help?',
        message:
          'Is there currently a domestic violence protective order or restraining order issued against you?',
      },
    },
    collection: {
      summary: {
        title: 'Summary of charges',
        item: 'Charge',
        unknown: 'Provide charge details below',
      },
      appendTitle: 'Do you have any other offenses where any of the following has happened to you?',
      appendMessage: [
        '- **In the last {{numberOfYearsString}}** have you been issued a summons, citation, or ticket to appear in court in a criminal proceeding against you? Do not check if all the citations involved traffic infractions where the fine was than $300 and did not include alcohol or drugs.',
        '- **In the last {{numberOfYearsString}}** have you been arrested by any police officer, sheriff, marshal or any other type of law enforcement official?',
        '- **In the last {{numberOfYearsString}}** have you been charged with, convicted of, or sentenced for a crime in any court? Include all qualifying charges, convictions or sentences in any federal, state, local, military, or non-U.S. court, even if previously listed on this form.',
        '- **In the last {{numberOfYearsString}}** have you been or are you currently on probation or parole?',
        '- Are you currently on trial or awaiting a trial on criminal charges?',
      ],
      append: 'Add another offense',
    },
  },
  investigations: {
    history: {
      heading: {
        title:
          'Has the U.S. Government (or a foreign government) EVER investigated your background and/or granted you a security clearance eligibility/access?',
        wasClearanceGranted: 'Was a clearance eligibility/access granted?',
        agency: 'Provide the investigating agency',
        completed: 'Date the investigation was completed',
        issued:
          'Provide the name of agency that issued the clearance eligibility/access if different from the investigating agency',
        granted: 'Provide the date clearance eligibility/access was granted',
        clearance: 'Provide the level of clearance eligibility/access granted',
        agencyExplanation: 'Provide the name of the bureau, government, or explanation',
        clearanceExplanation: 'Provide an explanation',
      },
      label: {
        idk: "I don't know",
        agency: {
          dod: 'U.S. Department of Defense',
          dos: 'U.S. Department of State',
          opm: 'U.S. Office of Personnel Management',
          fbi: 'Federal Bureau of Investigation',
          dot: 'U.S. Department of Treasury (provide name of bureau)',
          dhs: 'U.S. Department of Homeland Security',
          foreign: 'Foreign government (provide name of government)',
          other: 'Other (provide explanation)',
        },
        level: {
          none: 'None',
          confidential: 'Confidential',
          secret: 'Secret',
          topsecret: 'Top Secret',
          sci: 'Sensitive Compartmented Information (SCI)',
          q: 'Q',
          l: 'L',
          foreign: 'Issued by foreign country',
          other: 'Other (provide explanation)',
        },
      },
      para: {
        or: 'or',
      },
      collection: {
        description: 'Summary of investigations',
        item: 'Investigation',
        unknown: 'Provide investigation details below',
        appendTitle: 'Do you have another investigation to enter?',
        appendLabel: 'Add another investigation',
      },
      help: {
        agency: {
          title: 'Need help with this investigative agency?',
          message:
            'If you are not sure of the agency issuing the investigation click "I don\'t know".',
          note: '',
        },
        agencyExplanation: {
          title: 'Need help explaining this agency?',
          message: 'Provide any further explanation or name(s) required.',
          note: '',
        },
        completed: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        issued: {
          title: 'Need help with who issued this clearance?',
          message:
            'If an agency besides the one who initiated the investigation issued your clearance please tell us.',
          note: '',
        },
        granted: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        clearance: {
          title: 'Need help with which clearance was granted?',
          message: 'If you are not sure of the clearance being issued click "I don\'t know".',
          note: '',
        },
        clearanceExplanation: {
          title: 'Need help explaining this clearance?',
          message: 'Provide any further explanation regarding the clearance.',
          note: '',
        },
      },
    },
    revoked: {
      heading: {
        title:
          'In the last {{numberOfYearsString}} have you had a security clearance eligibility/access authorization denied, suspended, or revoked?',
        titleEver:
          'Have you EVER had a security clearance eligibility/access authorization denied, suspended, or revoked?',
        date:
          'Provide the date security clearance eligibility/access authorization was denied, suspended or revoked',
        agency: 'Provide the name of the agency that took the action',
        explanation:
          'Provide an explanation of the circumstances of the denial, suspension or revocation action',
      },
      para: {
        downgrade:
          'Note: An administrative downgrade or administrative termination of a security clearance is not a revocation.',
      },
      collection: {
        description: 'Summary of denials',
        item: 'Denial',
        unknown: 'Provide denial details below',
        appendTitle:
          'Do you have another denied, revoked, or suspended security clearance eligibility/access authorization to enter?',
        appendLabel: 'Add another denial',
      },
      help: {
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        agency: {
          title: 'Need help with the agency authorization this termination?',
          message:
            'Provide the agency name to the best of your abilities responsible for authorizing this action.',
          note: '',
        },
        explanation: {
          title: 'Details of this denial, suspension or revocation action',
          message: 'Go into as much detail as necessary.',
          note: '',
        },
      },
    },
    debarred: {
      heading: {
        title:
          'In the last {{numberOfYearsString}} have you been debarred from government employment?',
        titleEver: 'Have you EVER been debarred from government employment?',
        agency: 'Provide the name of the government agency taking debarment action',
        date: 'Provide the date the debarment occurred',
        explanation: 'Provide an explanation of the circumstances of the debarment',
      },
      collection: {
        description: 'Summary of debarments',
        item: 'Debarment',
        unknown: 'Provide debarment details below',
        appendTitle: 'Do you have another Government debarment to enter?',
        appendLabel: 'Add another debarment',
      },
      help: {
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        agency: {
          title: 'Need help with the agency taking the debarment action?',
          message:
            'Provide the agency name to the best of your abilities responsible for this action.',
          note: '',
        },
        explanation: {
          title: 'Details of this denial, suspension or revocation action',
          message: 'Go into as much detail as necessary.',
          note: '',
        },
      },
    },
  },
  nonCriminalAction: {
    heading: {
      hasCourtActions:
        'In the last {{numberOfYearsString}}, have you been a party to any public record civil court action not listed elsewhere on this form?',
      civilActionDate: 'Provide the date of the civil action',
      courtName: 'Provide the court name',
      courtAddress: 'Provide the address of the court',
      natureOfAction: 'Provide details of the nature of the action',
      resultsOfAction: 'Provide a description of the results of the action',
      principalPartyNames:
        'Provide the name(s) of the principal parties involved in the court action',
    },
    collection: {
      description: 'Summary of court actions',
      summary: 'Provide your court action details below',
      appendTitle: 'Are there any other civil court actions in the last ten (10) years to report?',
      appendLabel: 'Add another court action',
      itemType: 'Court Action',
    },
    help: {
      civilActionDate: {
        title: "Can't remember the exact date?",
        message: 'Give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      courtName: {
        title: 'Need help with the court name?',
        message: 'Provide the name of the court',
        note: '',
      },
      courtAddress: {
        title: 'Try looking up the court name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      natureOfAction: {
        title: 'Need help with the nature of the action?',
        message: 'Provide the address of the court',
        note: '',
      },
      resultsOfAction: {
        title: 'Need help with the results of the action?',
        message: 'Provide a description of the results of the action',
        note: '',
      },
      principalPartyNames: {
        title: 'Need help with the principal parties involved?',
        message: 'Provide the name(s) of the principal parties involved in the court action',
        note: '',
      },
    },
  },
  technology: {
    unauthorized: {
      heading: {
        title:
          'In the last seven (7) years have you illegally or without proper authorization accessed or attempted to access any information technology system?',
        date: 'Provide the date of the incident',
        incident: 'Provide a description of the nature of the incident or offense',
        location: 'Provide the location where the incident took place',
        action:
          'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
      },
      para: {
        intro: [
          'We note, with reference to this section, that neither your truthful responses nor information derived from your responses to this section will be used as evidence against you in a subsequent criminal proceeding.',
          'As to this particular section, this applies whether or not you are currently employed by the Federal government. The following questions ask about your use of information technology systems. Information technology systems include all related computer hardware, software, firmware, and data used for the communication, transmission, processing, manipulation, storage or protection of information.',
        ],
      },
      collection: {
        description: 'Summary of unauthorized access',
        item: 'Access',
        unknown: 'Provide unauthorized access details below',
        appendTitle: 'Are there any other incidents to report?',
        appendLabel: 'Add another unauthorized access',
      },
      help: {
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        incident: {
          title: 'Need help with the nature of this offense?',
          message: 'Provide a description of the offense.',
          note: '',
        },
        location: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        action: {
          title: 'Need help with any actions as a result of this incident?',
          message: 'Provide all actions which took place as a result of this incident.',
          note: '',
        },
      },
    },
    manipulating: {
      heading: {
        title:
          'In the last seven (7) years have you illegally or without authorization, modified, destroyed, manipulated, or denied others access to information residing on an information technology system or attempted any of the above?',
        date: 'Provide the date of the incident',
        incident: 'Provide a description of the nature of the incident or offense',
        location: 'Provide the location where the incident took place',
        action:
          'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
      },
      collection: {
        description: 'Summary of modified, destroyed, manipulated, or denied access',
        item: 'Incident',
        unknown: 'Provide details below',
        appendTitle: 'Are there any other incidents to report?',
        appendLabel: 'Add another incident',
      },
      help: {
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        incident: {
          title: 'Need help with the nature of this offense?',
          message: 'Provide a description of the offense.',
          note: '',
        },
        location: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        action: {
          title: 'Need help with any actions as a result of this incident?',
          message: 'Provide all actions which took place as a result of this incident.',
          note: '',
        },
      },
    },
    unlawful: {
      heading: {
        title:
          'In the last seven (7) years have you introduced, removed, or used hardware, software, or media in connection with any information technology system without authorization, when specifically prohibited by rules, procedures, guidelines, or regulations or attempted any of the above?',
        date: 'Provide the date of the incident',
        incident: 'Provide a description of the nature of the incident or offense',
        location: 'Provide the location where the incident took place',
        action:
          'Provide a description of the action (administrative, criminal or other) taken as a result of this incident',
      },
      collection: {
        description: 'Summary of unlawful use',
        item: 'Use',
        unknown: 'Provide details below',
        appendTitle: 'Are there any other incidents to report?',
        appendLabel: 'Add another unlawful use',
      },
      help: {
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        incident: {
          title: 'Need help with the nature of this offense?',
          message: 'Provide a description of the offense.',
          note: '',
        },
        location: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        action: {
          title: 'Need help with any actions as a result of this incident?',
          message: 'Provide all actions which took place as a result of this incident.',
          note: '',
        },
      },
    },
  },
  associations: {
    terrorist: {
      heading: {
        title:
          "Are you now or have you EVER been a member of an organization dedicated to terrorism, either with an awareness of the organization's dedication to that end, or with the specific intent to further such activities?",
        organization: 'Provide the full name of the organization',
        address: 'Provide the address/location of the organization',
        dates: 'Provide the dates of your involvement with the organization',
        positions: 'Provide all positions held in the organization, if any',
        contributions: 'Provide all contributions made to the organization, if any',
        reasons:
          'Provide a description of the nature of and reasons for your involvement with the organization',
      },
      para: {
        intro: [
          'The following pertain to your associations. You are required to answer the questions fully and truthfully, and your failure to do so could be grounds for an adverse employment, security, or credentialing decision.',
          'For the purpose of this question, terrorism is defined as any criminal acts that involve violence or are dangerous to human life and appear to be intended to intimidate or coerce a civilian population to influence the policy of a government by intimidation or coercion or to affect the conduct of a government by mass destruction, assassination or kidnapping.',
        ],
        introWithoutSecurity: [
          'The following pertain to your associations. You are required to answer the questions fully and truthfully, and your failure to do so could be grounds for an adverse employment or credentialing decision.',
          'For the purpose of this question, terrorism is defined as any criminal acts that involve violence or are dangerous to human life and appear to be intended to intimidate or coerce a civilian population to influence the policy of a government by intimidation or coercion or to affect the conduct of a government by mass destruction, assassination or kidnapping.',
        ],
        or: 'or',
      },
      label: {
        noposition: 'No positions held',
        nocontribs: 'No contributions made',
      },
      collection: {
        description: 'Summary of terrorist organizations',
        item: 'Organization',
        unknown: 'Provide details of organization below',
        appendTitle:
          "Do you have any other instances of being a member of an organization dedicated to terrorism, either with an awareness of the organization's dedication to that end, or with the specific intent to further such activities to report?",
        appendLabel: 'Add another terrorist organization',
      },
      help: {
        organization: {
          title: 'Need help with this organization name?',
          message: 'Provide the name of the organization.',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        positions: {
          title: 'Need help with positions held?',
          message: 'Provide any positions held during this time.',
          note: 'Note: If you didn\'t hold a position please click "No positions held."',
        },
        contributions: {
          title: 'Need help with contributions?',
          message: 'Provide any contributions made to organization.',
          note: 'Note: If you didn\'t provide any contributions click "No contributions made."',
        },
        reasons: {
          title: 'Need help with the nature and reasons of this incident?',
          message:
            'Provide an explanation of events surrounding this incident to the best of your knowledge.',
          note: '',
        },
      },
    },
    engaged: {
      heading: {
        title: 'Have you EVER knowingly engaged in any acts of terrorism?',
        reasons: 'Describe the nature and reasons for the activity',
        dates: 'Provide the dates for any such activities',
      },
      collection: {
        description: 'Summary of acts of terrorism',
        item: 'Act',
        unknown: 'Provide details for the terrorism below',
        appendTitle:
          'Do you have any other instances of knowingly engaging in acts of terrorism to report?',
        appendLabel: 'Add another act of terrorism',
      },
      help: {
        reasons: {
          title: 'Need help with the nature and reasons of this incident?',
          message:
            'Provide an explanation of events surrounding this incident to the best of your knowledge.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
    },
    advocating: {
      heading: {
        title:
          'Have you EVER advocated any acts of terrorism or activities designed to overthrow the U.S. Government by force?',
        reasons: 'Provide the reason(s) for advocating acts of terrorism',
        dates: 'Provide the dates of advocating acts of terrorism',
      },
      collection: {
        description: 'Summary of advocating terrorism',
        item: 'Instance',
        unknown: 'Provide details of the instance below',
        appendTitle:
          'Do you have any other instances of advocating acts of terrorism or activities designed to overthrow the U.S. Government by force to report?',
        appendLabel: 'Add another instance',
      },
      help: {
        reasons: {
          title: 'Need help with the nature and reasons of this incident?',
          message:
            'Provide an explanation of events surrounding this incident to the best of your knowledge.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
    },
    overthrow: {
      heading: {
        title:
          "Have you EVER been a member of an organization dedicated to the use of violence or force to overthrow the United States Government, and which engaged in activities to that end with an awareness of the organization's dedication to that end or with the specific intent to further such activities?",
        organization: 'Provide the full name of the organization',
        address: 'Provide the address/location of the organization',
        dates: 'Provide the dates of your involvement with the organization',
        positions: 'Provide all positions held in the organization, if any',
        contributions: 'Provide all contributions made to the organization, if any',
        reasons:
          'Provide a description of the nature of and reasons for your involvement with the organization',
      },
      para: {
        or: 'or',
      },
      label: {
        noposition: 'No positions held',
        nocontribs: 'No contributions made',
      },
      collection: {
        description: 'Summary of memberships',
        item: 'Membership',
        unknown: 'Please provide membership details below',
        appendTitle:
          'Do you have any other instances of being a member of an organization dedicated to the use of violence or force to overthrow the United States Government, which engaged in activities to that end with an awareness of the organization’s dedication to that end or with the specific intent to further such activities to report?',
        appendLabel: 'Add another membership',
      },
      help: {
        organization: {
          title: 'Need help with this organization name?',
          message: 'Provide the name of the organization.',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        positions: {
          title: 'Need help with positions held?',
          message: 'Provide any positions held during this time.',
          note: 'Note: If you didn\'t hold a position please click "No positions held."',
        },
        contributions: {
          title: 'Need help with contributions?',
          message: 'Provide any contributions made to organization.',
          note: 'Note: If you didn\'t provide any contributions click "No contributions made."',
        },
        reasons: {
          title: 'Need help with the nature and reasons of this incident?',
          message:
            'Provide an explanation of events surrounding this incident to the best of your knowledge.',
          note: '',
        },
      },
    },
    violence: {
      heading: {
        title:
          'Have you EVER been a member of an organization that advocates or practices commission of acts of force or violence to discourage others from exercising their rights under the U.S. Constitution or any state of the United States with the specific intent to further such action?',
        organization: 'Provide the full name of the organization',
        address: 'Provide the address/location of the organization',
        dates: 'Provide the dates of your involvement with the organization',
        positions: 'Provide all positions held in the organization, if any',
        contributions:
          'Provide all contributions (in U.S. dollars) made to the organization, if any',
        reasons:
          'Provide a description of the nature of and reasons for your involvement with the organization',
      },
      para: {
        or: 'or',
      },
      label: {
        noposition: 'No positions held',
        nocontribs: 'No contributions made',
      },
      collection: {
        description: 'Summary of memberships',
        item: 'Membership',
        unknown: 'Provide membership details below',
        appendTitle:
          'Do you have any other instances of being a member of an organization that advocates or practices commission of acts of force or violence to discourage others from exercising their rights under the U.S. Constitution or any state of the United States with the specific intent to further such action to report',
        appendLabel: 'Add another membership',
      },
      help: {
        organization: {
          title: 'Need help with this organization name?',
          message: 'Provide the name of the organization.',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        positions: {
          title: 'Need help with positions held?',
          message: 'Provide any positions held during this time.',
          note: 'Note: If you didn\'t hold a position please click "No positions held."',
        },
        contributions: {
          title: 'Need help with contributions?',
          message: 'Provide any contributions made to organization.',
          note: 'Note: If you didn\'t provide any contributions click "No contributions made."',
        },
        reasons: {
          title: 'Need help with the nature and reasons of this incident?',
          message:
            'Provide an explanation of events surrounding this incident to the best of your knowledge.',
          note: '',
        },
      },
    },
    activities: {
      heading: {
        title:
          'Have you EVER knowingly engaged in activities designed to overthrow the U.S. Government by force?',
        reasons: 'Describe the nature and reasons for the activity',
        dates: 'Provide the dates of such activities',
      },
      collection: {
        description: 'Summary of acts of terrorism',
        item: 'Activity',
        unknown: 'Provide details below',
        appendTitle:
          'Do you have any other instances of having knowingly engaged in activities designed to overthrow the U.S. Government by force to report?',
        appendLabel: 'Add another activity',
      },
      help: {
        reasons: {
          title: 'Need help with the nature and reasons of this activity?',
          message:
            'Provide an explanation of events surrounding this activity to the best of your knowledge.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
    },
    terrorism: {
      heading: {
        title: 'Have you EVER associated with anyone involved in activities to further terrorism?',
        explanation: 'Provide explanation',
      },
      help: {
        explanation: {
          title: 'Need help with this explanation?',
          message:
            'If you have ever known or been in association with anyone who was involved in terrorist activities provide an explanation of the circumstances.',
          note: '',
        },
      },
    },
  },
};
